<template>
  <div class="animated fadeIn" id="fiche_dossier">
    <scroll-bottom visibleoffset="500" top="60px" right="10px">
        <button type="button" class="btn btn-primary btn-to-top"><i class="fa fa-chevron-down"></i></button>
    </scroll-bottom>
    <b-card no-body>
      <div class="card-smallHeader dark">
        <i class="fa fa-justify mr-2"></i>
        <strong>Dossier n° {{ dossier.id }} / {{ displayedData.dateReception }}</strong> <span class="pull-right"><b>Statut actuel : <span
        class="ml-2" style="color: #1c00ff">{{ statutActuelLibelle }}</span></b><span> ({{ currentTreatment.libelle }})</span></span>
      </div>
      <div class="body-card m-2">
        <b-card no-body>
          <div class="card-smallHeader card-header-action" v-b-toggle.collapse-type-produit
               :aria-expanded="isTraitementQCTypeProduit ? 'true' : 'false'">
            <span v-if="isEmptyObject(dossier.type)"><b>Type de dossier / produit : </b></span>
            <span v-if="dossier.type && !isEmpty(dossier.type.libelle)" style="color: #349ee2" class="mr-1"><b>{{ dossier.type.libelle }}</b></span>
            <span v-if="!isEmpty(dossier.famille_produit)" style="color: #d9418b" class="mr-2">
              <span style="color:black;">/ </span>
              <b>{{dossier.famille_produit.libelle }}</b>
            </span>
            <span><i class="fa fa-exclamation text-danger ml-2" v-if="errors.selectedType !== '' || errors.selectedFamilleProduit !== ''"></i></span>
            <div class="card-header-actions">
              <span class="when-opened">
                <i class="icon-arrow-down"></i>
              </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <b-collapse id="collapse-type-produit" v-model="isTraitementQCTypeProduit" class="m-3" :class="isTraitementQCTypeProduit ? null : 'collapsed'">
            <b-row>
              <b-col sm="6">
                <b-form-group v-if="dossier.type && !isEmpty(dossier.type.libelle) && (dossier.type.libelle_technique === 'ij-bpij' || dossier.type.libelle_technique === 'bpijo' || dossier.type.libelle_technique === 'bpijp')"
                              label-for="type2"
                              :label-cols="3"
                              :horizontal="true">
                  <template slot="label"><b>Type dossier</b></template>
                  <b-form-input type="text" v-model="dossier.type.libelle" disabled></b-form-input>
                </b-form-group>

                <b-form-group v-else
                  label-for="type2"
                  :label-cols="4"
                  :horizontal="true">
                  <template slot="label"><b>Type dossier</b></template>
                  <b-form-select v-model="selectedType" :disabled="isDisabled('selectedType')" :options="allTypesOption"
                                 :class="{hasError: errors.selectedType !== ''}">
                  </b-form-select>
                  <span class="field-error">{{ errors.selectedType }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                  label-for="produitQC"
                  :label-cols="4"
                  :horizontal="true">
                  <template slot="label"><b>Produit</b></template>
                  <b-form-select id="produitQC"
                                 v-model="selectedFamilleProduit"
                                 :disabled="isDisabled('produitQC')"
                                 :class="{hasError: errors.selectedFamilleProduit !== ''}">
                    <b-form-select-option-group v-for="(produits, group) in groupSelectOption" :label="group.toUpperCase()" :key="group">
                      <b-form-select-option v-for="produit in produits" :key="produit.value" :value="produit.value">{{ produit.text }}</b-form-select-option>
                    </b-form-select-option-group>

                  </b-form-select>
                  <span class="field-error">{{ errors.selectedFamilleProduit }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col sm="12" lg="12">
                <b-form-group
                  label-for="type2"
                  :label-cols="2"
                  label-cols-lg="2"
                  :horizontal="true">
                  <template slot="label"><b>Type Urgence</b></template>
                  <b-form-radio-group id="typeUrgence" :disabled="!canChangePrioritaire()" v-model="typeUrgence" name="typeUrgence" class="set_dossier_urgent" style="margin-top:8px">
                    <b-form-radio value="">Aucune</b-form-radio>
                    <b-form-radio value="urgences_directions">Urgences Directions</b-form-radio>
                    <b-form-radio value="lignes_rouges">Lignes Rouges</b-form-radio>
                    <b-form-radio value="mog">MOG</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col sm="12" lg="12">
                <b-form-group
                  label-for="type2"
                  :label-cols="2"
                  label-cols-lg="2"
                  :horizontal="true">
                  <template slot="label"><b>Fiche Tél Webhelp</b></template>
                  <b-form-radio-group id="typeUrgence" :disabled="!canChangePrioritaire()" v-model="typeUrgence" name="typeUrgence" class="set_dossier_urgent" style="margin-top:8px">
                    <b-form-radio value="fiche_telephonique"></b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
        </b-card>
        <b-card no-body>
          <div class="card-smallHeader card-header-action" v-b-toggle.collapse-beneficiaire
               :aria-expanded="isAssureOpen ? 'true' : 'false'">
            <span v-if="isEmpty(displayedData.nom)"><b>Assuré/Bénéficiaire : </b></span>
            <span v-if="!isEmpty(displayedData.nirWithoutKey)" style="color: #1c1b1b;" class="mr-2">
              <b>{{ displayedData.nirWithoutKey }}</b>
              <label style="color:#f86c6b">{{ dataSirens.nbSiren }}</label></span>
            <span v-if="!isEmpty(displayedData.nom)" style="color: #349ee2" class="mr-2"><b>{{ displayedData.nom }}</b></span>
            <span v-if="!isEmpty(displayedData.prenom)" style="color: #349ee2" class="mr-2"><b>{{ displayedData.prenom }}</b></span>
            <span v-if="nbIdpps > 1" style="color: #f86c6b" class="mr-2"><b>(doublon ID PP NSI)</b></span>
            <span><i class="fa fa-exclamation text-danger ml-2" v-if="errors.ppNumber !== '' || errors.nirWithoutKey !== '' || errors.nom !== '' || errors.prenom !== '' || errors.email !== ''"></i></span>
            <div class="card-header-actions">
              <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <b-collapse id="collapse-beneficiaire" v-model="isAssureOpen" class="m-3"
                      :class="isAssureOpen ? null : 'collapsed'">
            <b-row class="mb-3" v-if="!isDisabled('nirSearch')">
              <b-col sm="1" style="margin-right: -4px;"></b-col>
              <b-col sm="5">
                <auto-select
                  class="col-sm-11"
                  id="nirList"
                  v-model="nir"
                  :items="nirList"
                  :loading="loadingNir"
                  item-value="id"
                  item-text="nom"
                  :placeholder="nir ? '' : 'Saisir le NIR'"
                  disable-filtering-by-search
                  @search="onSearchNir"
                  v-on:keyup.enter="onEnter('nirList')">
                  <template #no-data>
                    <span style="color: red">{{ noData ? "Aucun nir trouvé." : "Il faut au moins 5 caractères pour la recherche." }}</span>
                  </template>
                  <template slot="item" slot-scope="{ item: affiliation }">
                    <div style="display: flex;" @click="onClick($event, affiliation, 'affiliation')">
                      <span class="item-name">
                        <span style="color: black;"> {{ affiliation.nom }} {{ affiliation.prenom }} </span>
                        <span style="color: #349ee2"> ({{ affiliation.nir }}) </span>
                        <span style="color: #d9418b"> ({{ affiliation.siren ? affiliation.siren.siren : 'n.d' }})</span>
                        <span style="color: #d9418b"> ({{ affiliation.famille_produit }})</span>
                        <span style="color: #d7cb71"> ({{ affiliation.id_pp || 'n.d' }})</span>
                      </span>
                    </div>
                  </template>
                  <template slot="selection" slot-scope="{ item: affiliation }">
                    <div style="display: flex; align-items: center;">
                      <span class="item-name">
                        <span style="color: black;"> {{ affiliation.nom }} {{ affiliation.prenom }} </span>
                        <span style="color: #349ee2"> ({{ affiliation.nir }}) </span>
                        <span style="color: #d9418b"> ({{ affiliation.siren ? affiliation.siren.siren : 'n.d' }})</span>
                        <span style="color: #d9418b"> ({{ affiliation.famille_produit }})</span>
                        <span style="color: #d7cb71"> ({{ affiliation.id_pp || 'n.d' }})</span>
                      </span>
                    </div>
                  </template>
                  <template v-if="loadingNir" #input-end>
                    <i class="fa fa-spinner fa-pulse fa-fw"></i>
                    <!-- <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator"> -->
                  </template>
                </auto-select>
                <i class="ml-2 clickable fa fa-undo" @click="raz()" v-b-tooltip.hover title="Effacer la séléction"></i>
              </b-col>
              <b-col sm="5">
                <auto-select
                  class="col-sm-11"
                  id="dossierList"
                  v-model="num_dossier"
                  :items="dossierList"
                  :loading="loadingDossier"
                  item-value="id"
                  item-text="nom"
                  :placeholder="num_dossier ? '' : 'Saisir le numero de dossier'"
                  disable-filtering-by-search
                  @search="onSearchDossier"
                  v-on:keyup.enter="onEnter('dossierList')">
                  <template #no-data>
                    <span style="color: red">{{ noData ? "Aucun dossier trouvé." : "Il faut au moins 5 caractères pour la recherche." }}</span>
                  </template>
                  <template slot="item" slot-scope="{ item: beneficiaire }">
                    <div style="display: flex;" @click="onClick($event, beneficiaire, 'beneficiaire')">
                      <span class="item-name">
                        <span style="color: black;"> {{ beneficiaire.nom }} {{ beneficiaire.prenom }} </span>
                        <span style="color: #349ee2"> ({{ beneficiaire.nir }}) </span>
                        <span style="color: #d9418b"> ({{ beneficiaire.siret.substring(0, 9) ? beneficiaire.siret.substring(0, 9) : 'n.d' }})</span>
                        <span style="color: #d9418b"> ({{ beneficiaire.famille_produit }})</span>
                        <span style="color: #d7cb71"> ({{ beneficiaire.id_pp || 'n.d' }})</span>
                      </span>
                    </div>
                  </template>
                  <template slot="selection" slot-scope="{ item: beneficiaire }">
                    <div style="display: flex; align-items: center;">
                      <span class="item-name">
                        <span style="color: black;"> {{ beneficiaire.nom }} {{ beneficiaire.prenom }} </span>
                        <span style="color: #349ee2"> ({{ beneficiaire.nir }}) </span>
                        <span style="color: #d9418b"> ({{ beneficiaire.siret.substring(0, 9) ? beneficiaire.siret.substring(0, 9) : 'n.d' }})</span>
                        <span style="color: #d9418b"> ({{ beneficiaire.famille_produit }})</span>
                        <span style="color: #d7cb71"> ({{ beneficiaire.id_pp || 'n.d' }})</span>
                      </span>
                    </div>
                  </template>
                  <template v-if="loadingDossier" #input-end>
                    <i class="fa fa-spinner fa-pulse fa-fw"></i>
                    <!-- <img src="https://i.imgur.com/mTNe6tr.gif" class="loading-indicator"> -->
                  </template>
                </auto-select>
                <i class="ml-2 clickable fa fa-undo" @click="raz()" v-b-tooltip.hover title="Effacer la séléction"></i>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <!-- <b-row> -->
                <b-form-group
                  label-for="nir"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>NIR sans clé</b></template>
                  <!-- <b-col sm="3">
                    <label><b>NIR sans clé</b></label>
                  </b-col>
                  <b-col sm="9"> -->
                    <b-form-input v-if="nirIndisponible" type="text" class="custom-input-reduit disabled-input"
                                      style="width:52%;" placeholder="Donnée non disponible" disabled>
                    </b-form-input>
                    <b-form-input type="text"
                                  id="nir"
                                  v-if="!nirIndisponible && !isDisabled('nirWithoutKey')"
                                  class="custom-input-reduit"
                                  :disabled="isDisabled('nirWithoutKey')"
                                  v-on:keydown="validateNirWithoutKey"
                                  v-model="nirWithoutKey"
                                  style="width: 52%;"
                                  :class="{hasError: errors.nirWithoutKey !== ''}">
                    </b-form-input>

                    <span v-if="!nirIndisponible && isDisabled('nirWithoutKey')" class="like-input-disabled reduit">{{ nirWithoutKey }}</span>
                    <b-form-checkbox v-if="!isDisabled('nirWithoutKey')" class="custom-checkbox"
                                     @change="nirIndisponible = !nirIndisponible"></b-form-checkbox>
                    <i v-if="!isDisabled('nirWithoutKey')" class="fa fa-question-circle mr-2" v-b-tooltip.hover title="Cochez cette case si vous n'avez pas l'information"></i>
                    <i v-if="validNir === true" class="fa fa-check text-success"></i>
                    <i v-if="validNir === false" class="fa fa-times-circle text-danger"></i>

                    <b-form-input type="text"
                                  id="keyNir"
                                  v-if="!isDisabled('keyNir')"
                                  :disabled="isDisabled('keyNir')"
                                  v-on:keydown="validateKeyNir"
                                  style="display:  inline-block;width: 20%;"
                                  class="custom-input-reduit pull-right"
                                  v-model="keyNir">
                    </b-form-input>
                    <span v-if="isDisabled('keyNir')" class="like-input-disabled reduit pull-right">{{ keyNir }}</span>
                    <label class="mr-2 mt-2 ml-2 pull-right"><b> Clé </b></label>
                    <span class="field-error">{{ errors.nirWithoutKey }}</span>
                  <!-- </b-col> -->
                  </b-form-group>
                  <!-- </b-row> -->
                </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="ppNumber1"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label">
                      <b>N°PP NSI</b>
                      <i class="fa fa-question-circle ml-2" v-b-tooltip.hover title="Source de la donnée : Fichier Affiliation"></i>
                  </template>

                  <b-form-input id="ppNumber1" v-if="!isDisabled('ppNumber')" :disabled="isDisabled('ppNumber')" v-model="ppNumber" type="text" :class="{hasError: errors.ppNumber !== ''}">
                  </b-form-input>
                  <span v-if="isDisabled('ppNumber')" class="like-input-disabled">{{ ppNumber }}</span>
                  <span class="field-error">{{ errors.ppNumber }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  v-if="nbIdpps > 1"
                  label-for="select-idpp"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Doublon ID_PP</b></template>
                  <b-form-select v-model="selectedIdpp" :options="idppOptions"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
             <b-col sm="4">
                <b-form-group
                  label-for="idppApi"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label">
                      <b>N°PP NSI API</b>
                      <i class="fa fa-question-circle ml-2" v-b-tooltip.hover title="Source de la donnée : API NSI"></i>
                  </template>
                  <span v-if="!loadingIdppApi" class="like-input-disabled">{{ idppApi }}</span>
                  <loading-field v-if="loadingIdppApi" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <b-form-group
                  label-for="insuredLastName"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Nom de naissance</b></template>
                  <b-form-input id="insuredLastName" v-if="!isDisabled('nom_naissance')" :disabled="isDisabled('nom_naissance')" v-model="nom_naissance" type="text"
                                :class="{hasError: errors.nom_naissance !== ''}">
                  </b-form-input>
                  <span v-if="isDisabled('nom_naissance')" class="like-input-disabled">{{ nom_naissance }}</span>
                  <span class="field-error">{{ errors.nom_naissance }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="insuredUsedName"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Nom d'usage (épouse)</b></template>
                  <b-form-input id="insuredUsedName" v-if="!isDisabled('nom')" :disabled="isDisabled('nom')" v-model="nom" type="text"
                                :class="{hasError: errors.nom !== ''}">
                  </b-form-input>
                  <span v-if="isDisabled('nom')" class="like-input-disabled">{{ nom }}</span>
                  <span class="field-error">{{ errors.nom }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="insuredFirstName"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Prénom assuré&middot;e</b></template>
                  <b-form-input id="insuredFirstName" v-if="!isDisabled('prenom')" :disabled="isDisabled('prenom')" v-model="prenom" type="text"
                                :class="{hasError: errors.prenom !== ''}">
                  </b-form-input>
                  <span v-if="isDisabled('prenom')" class="like-input-disabled">{{ prenom }}</span>
                  <span class="field-error">{{ errors.prenom }}</span>
                </b-form-group>
              </b-col>
            </b-row>
           <b-row>
              <b-col sm="4">
                <b-form-group
                  label-for="insuredBirthDate"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Date de naissance</b></template>
                  <b-form-input class="custom-input-reduit" id="insuredBirthDate" v-if="!isDisabled('date_naissance')" :disabled="isDisabled('date_naissance')" v-model="date_naissance" type="date">
                  </b-form-input>
                  <span v-if="isDisabled('date_naissance')" class="like-input-disabled reduit">{{ shortFormatDate(date_naissance) }}</span>
                  <i class="fa fa-question-circle ml-2" v-b-tooltip.hover v-bind:title="afficheSourceDateNaissance()"></i>
                  <span class="field-error">{{ errors.date_naissance }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="insuredEmail"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Email</b></template>
                  <b-form-input id="insuredEmail" v-if="!isDisabled('email')" :disabled="isDisabled('email')" v-model="email" type="text">
                  </b-form-input>
                  <span v-if="isDisabled('email')" class="like-input-disabled">{{ email }}</span>
                  <span class="field-error">{{ errors.email }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="insuredTelephone"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Téléphone</b></template>
                  <b-form-input id="insuredTelephone" v-if="!isDisabled('telephone')" :disabled="isDisabled('telephone')" v-model="telephone" type="text">
                  </b-form-input>
                  <span v-if="isDisabled('telephone')" class="like-input-disabled">{{ telephone }}</span>
                  <span class="field-error">{{ errors.telephone }}</span>
                </b-form-group>
              </b-col>
            </b-row>
           <b-row>
              <b-col sm="4">
                <b-form-group
                  label-for="insuredAdresse1"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Adresse 1</b></template>
                  <b-form-input id="insuredAdresse1" v-if="!isDisabled('adresse1')" :disabled="isDisabled('adresse1')" v-model="adresse1" type="text">
                  </b-form-input>
                  <span v-if="isDisabled('adresse1')" class="like-input-disabled">{{ adresse1 }}</span>
                  <span class="field-error">{{ errors.adresse1 }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="insuredAdresse2"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Code postal Ville</b></template>
                  <b-form-input id="insuredAdresse2" v-if="!isDisabled('adresse2')" :disabled="isDisabled('adresse2')" v-model="adresse2" type="text">
                  </b-form-input>
                  <span v-if="isDisabled('adresse2')" class="like-input-disabled">{{ adresse2 }}</span>
                  <span class="field-error">{{ errors.adresse2 }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4" v-if="showCheckboxChangeContact">
                <b-form-checkbox
                  id="changementContact"
                  v-model="changementContact"
                  name="changementContact"
                  value="changed"
                  unchecked-value="unchanged"
                >
                  Changement dans les informations de contact
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row v-if="getTypeDossier() === 'inval'">
              <b-col style="border-right: 1px solid #dcdcdc; border-top: 1px solid #dcdcdc; border-bottom: 1px solid #dcdcdc; position: relative;">
                <b-row>
                  <b-col sm="12" style="position: relative; top: -12px;">
                  <span style="background-color: #FFFFFF; padding: 0 5px;"><b>Informations Espace Bénéficiaire : </b></span>
            </b-col>
          </b-row>
          <b-row v-if="getTypeDossier() === 'inval'">
              <b-col sm="4">
                <b-form-group
                  label-for="isBeneficiaireActif"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Compte Actif</b></template>
                  <b-form-checkbox
                      style="padding-top: calc(0.375rem + 1px);"
                        id="isBeneficiaireActif"
                        v-model="displayedData.isBeneficiaireActif"
                        name="isBeneficiaireActif"
                        switch disabled>
                        {{ displayedData.isBeneficiaireActif ? 'Oui' : 'Non'}}
                      </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="emailBeneficiaire"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Email Bénéficiaire</b></template>
                  <span class="like-input-disabled">{{ displayedData.emailBeneficiaire }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="dateConnexion"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Date connexion</b></template>
                  <!-- <span v-if="!isEmpty(displayedData.dateConnexion)" style="color: #d9418b" class="mr-2"><i>Dernière connexion le : {{ displayedData.dateConnexion }}</i></span> -->

                  <span class="like-input-disabled">{{ displayedData.dateConnexion }}</span>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          </b-row>
            <div>
              <b-button class="float-right mt-2 mb-1 mr-1" variant="info" @click="showFicheAssure(displayedData.nirWithoutKey,oag,oap)"
                        :disabled="isEmpty(displayedData.nirWithoutKey)">Voir fiche Assurére
              </b-button>
            </div>
          </b-collapse>
        </b-card>
        <b-card no-body>
          <div class="card-smallHeader card-header-action" v-b-toggle.collapse-adherent :aria-expanded="isAdherentTabOpen ? 'true' : 'false'">
            <span v-if="adherentEmpty"><b>Adhérent : </b></span>
            <span style="color: #d9418b" class="mr-2"><b> {{ displayedData.siren }} {{ displayedData.nic }}</b></span>
            <span style="color: #349ee2" class="mr-2"><b> {{ displayedData.raisonSociale }} </b></span>
            <span><i class="fa fa-exclamation text-danger ml-2" v-if="errors.siren !== ''"></i></span>
            <div class="card-header-actions">
              <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
              <span class="when-closed">
                <i class="icon-arrow-up"></i>
              </span>
            </div>
            <span class="mr-2 pull-right">OAP : <b><span style="color: #ffa434">{{ oap }} </span></b></span>
            <span class="mr-2 pull-right">OAG : <b><span style="color: #ff0032">{{ oag }} </span></b></span>
          </div>
          <b-collapse id="collapse-adherent" class="m-3" v-model="isAdherentTabOpen" :class="isAdherentTabOpen ? null : 'collapsed'">
            <b-row>
              <b-col sm="4">
                <b-form-group
                  label-for="raisonSociale"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Raison sociale </b></template>
                  <!-- <b-form-input id="raisonSociale" disabled v-model="raisonSociale" type="text"></b-form-input> -->
                  <span class="like-input-disabled" id="identifiant-tooltip-raison-sociale">{{ getRaisonSociale(raisonSociale).libelle }}</span>
                  <b-tooltip v-if="getRaisonSociale(raisonSociale).isTruncated" target="identifiant-tooltip-raison-sociale" triggers="hover" placement="top">{{ raisonSociale }}</b-tooltip>
                  <!-- <span v-if="raisonSociale.length < 48" class="like-input-disabled">{{ raisonSociale }}</span> -->

                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="siren"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>SIREN</b></template>
                  <b-form-input v-if="sirenIndisponible" type="text" class="custom-input-reduit disabled-input"
                                style="width:52%;" placeholder="Donnée non disponible" disabled></b-form-input>
                  <b-form-input type="text"
                                id="siren"
                                v-if="!sirenIndisponible && !isDisabled('siren')"
                                class="custom-input-reduit"
                                v-on:keyup="validateSiren"
                                :disabled="isDisabled('siren')"
                                v-model="siren"
                                style="width:52%;"
                                :class="{hasError: errors.siren !== ''}">
                  </b-form-input>
                  <span v-if="!sirenIndisponible && isDisabled('siren')" class="like-input-disabled reduit">{{ siren }}</span>
                  <b-form-checkbox v-if="!isDisabled('siren')" class="custom-checkbox"
                                   @change="sirenIndisponible = !sirenIndisponible"></b-form-checkbox>
                  <i v-if="!isDisabled('siren')" class="fa fa-question-circle" v-b-tooltip.hover title="Cochez cette case si vous n'avez pas l'information"></i>
                  <!-- <span v-if="!isDisabled('siren')" class="field-error">{{ errors.siren }}</span> -->
                  <i v-if="validateSiren === true" class="fa fa-check text-success"></i>
                  <i v-if="validateSiren === false" class="fa fa-times-circle text-danger"></i>

                  <b-form-input type="text" id="nic" maxlength="5"
                                v-if="!isDisabled('nic')"
                                :disabled="isDisabled('nic')"
                                v-on:keydown="validateNic"
                                style="display:inline-block;width:20%;"
                                class="pull-right"
                                v-model="nic">
                  </b-form-input>
                  <span v-if="isDisabled('nic')" class="like-input-disabled reduit pull-right">{{ nic }}</span>
                  <label class="mr-2 mt-2 pull-right"><b> NIC </b></label>
                  <span class="field-error">{{ errors.nic }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="segment"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Segment</b></template>
                  <b-form-input id="segment" disabled v-model="selectedSegmentLibelle" type="text">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <b-form-group
                  label-for="pmNumber"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label">
                      <b>N°PM NSI</b>
                  </template>
                  <b-form-input id="pmNumber" v-if="!isDisabled('pmNumber')" :disabled="isDisabled('pmNumber')" v-model="pmNumber" type="text">
                  </b-form-input>
                  <span v-if="isDisabled('pmNumber')" class="like-input-disabled">{{ pmNumber }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="dt"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>DT</b></template>
                  <b-form-input id="dt" :disabled="isDisabled('dt')" v-model="dt" type="text">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <b-form-group
                  label-for="statut_prestij"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Statut Prest'IJ</b></template>
                  <b-form-input id="statut_prestij" :disabled="isDisabled('statut_prestij')"
                                v-model="statut_prestij_libelle"
                                type="text">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="sirh"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>SIRH partenaire</b></template>
                  <b-form-input id="sirh" :disabled="isDisabled('sirhPartenaire')" v-model="sirhPartenaire" type="text"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="export"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Export SIRH</b></template>
                  <b-form-input id="export" :disabled="isDisabled('exportSirh')" v-model="exportSirh" type="text"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>

            </b-row>
            <b-row>
              <b-col sm="4">
                <b-form-group
                  label-for="declarantName"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Nom déclarant</b></template>
                  <b-form-input id="declarantName" v-if="!isDisabled('declarantName')"
                                :disabled="isDisabled('declarantName')" v-model="declarantName" type="text">
                  </b-form-input>
                  <span v-if="isDisabled('declarantName')" class="like-input-disabled">{{ declarantName }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="declarant_mail"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Mail déclarant</b></template>
                  <b-form-input id="declarant_mail" v-if="!isDisabled('declarantMail')" :disabled="isDisabled('declarantMail')" v-model="declarantMail"
                                type="text">
                  </b-form-input>
                  <span v-if="isDisabled('declarantMail')" class="like-input-disabled">{{ declarantMail }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group
                  label-for="declarant_tel"
                  :label-cols="3"
                  :horizontal="true">
                  <template slot="label"><b>Tel déclarant</b></template>
                  <b-form-input id="declarant_tel" v-if="!isDisabled('declarantTel')" :disabled="isDisabled('declarantTel')" v-model="declarantTel"
                                type="text">
                  </b-form-input>
                  <span v-if="isDisabled('declarantTel')" class="like-input-disabled">{{ declarantTel }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <div>
              <b-button class="float-right mt-2 mb-1 mr-1" variant="info" @click="ficheSiren"
                        :disabled="!showFicheSiren">Voir fiche SIREN
              </b-button>
            </div>
          </b-collapse>
        </b-card>
        <span v-if="alerteMultipleDossier !== ''"><img class="clickable" :src="getIconSrc('warning_26.png', dossier)"/> {{ alerteMultipleDossier }}</span>
      </div>
    </b-card>
    <transition name="fade">
      <b-card no-body>
        <div class="body-card mt-2 fiche-dossiers-tabs" :class="computedClass">
          <b-tabs content-class="" @input="onInput">
            <b-tab active>
              <template v-slot:title>
                Détails dossier
                <i class="fa fa-exclamation text-danger ml-2"
                   v-if="errors.date_du !== '' || errors.date_au !== '' || errors.montantIJSS !== '' || errors.dateReception !== '' || errors.dateReceptionCourrier !== '' || errors.causeSinistreId !== ''"></i>
              </template>
              <donnees-sinistre v-if="finished && isNotDbco" :dossier="dossier" :allTypes="allTypes" :selectedType="selectedType"></donnees-sinistre>
              <droit-assure v-if="finished && isTypeDc" :dossier="dossier" :allTypes="allTypes" :selectedType="selectedType" :allFamillesProduits="allFamillesProduits"></droit-assure>
              <completude-dossier v-if="finished && isTypeDc" :dossier="dossier" :allTypes="allTypes" :selectedType="selectedType" :allFamillesProduits="allFamillesProduits"></completude-dossier>
              <donnees-dbco v-if="finished && !isNotDbco" :dossier="dossier"></donnees-dbco>
              <aide-gestion v-if="finished && canAccessTab('aide')" :dossier="dossier" :traitements="allTraitements"></aide-gestion>
              <pieces-jointes v-if="finished" :dossier="dossier"></pieces-jointes>
            </b-tab>
            <b-tab v-for="(tab, index) in accessibleTabs" :key="index">
              <template #title>
                <b-spinner :id="'spinner_tab_' +tab.type" v-if="tab.loading" type="border" small></b-spinner> {{ tab.title }}
              </template>
              <component v-if="finished" :is="tab.type" v-bind={dossier:dossier,traitements:allTraitements,allTraitements:allTraitements,segments:allSegments,allStatus:allStatus}></component>
            </b-tab>
          </b-tabs>
        </div>
      </b-card>
    </transition>
      <b-card no-body>
        <div class="card-smallHeader dark">
          <i class="fa fa-justify mr-2"></i>
          <strong>Suivi dossier / Statut actuel : <span class="ml-2" style="color: #1c00ff">{{ statutActuelLibelle }}</span> </strong> ({{ currentTreatment.libelle }})
        </div>
        <div class="body-card m-3">
          <suivi-dossier v-if="finished" :dossier="dossier" :traitements="allTraitements"></suivi-dossier>
        </div>
        <div class="body-card mt-2" v-if="currentTreatment.type === 'Principal' && currentTreatment.categorie === 'Controle'">
          <!-- <b-button class="float-right mt-2 mb-1 mr-1" variant="info" @click="initiateSave('next')"
                    :disabled="disableNextButton()"><i class="fa fa-save"></i> Dossier Suivant <i class="fa fa-arrow-right"></i>
          </b-button> -->
          <b-button class="float-right mt-2 mb-1 mr-1" variant="secondary" @click="returnBackCampagne"><i
            class="fa fa-window-close"></i> Retour
          </b-button>
        </div>
        <div class="body-card mt-2" v-else>
          <fieldset :hidden="cantEditFicheDC(dossier)">
            <b-button v-if="!disableDuplication" class="float-right mt-2 mb-1 mr-1" variant="dark"
                      @click="duplicationModal"><i class="fa fa-save mr-1"></i><i class="fa fa-clone"></i>Dupliquer
            </b-button>
            <b-button class="float-right mt-2 mb-1 mr-1" variant="primary" @click="initiateSave('save'); getMotifsAnomalie(dossier)"><i class="fa fa-save"></i>
              Enregistrer
            </b-button>
            <b-button v-if="!disableReOpen" class="float-right mt-2 mb-1 mr-1" variant="warning"
                      @click="startReOpen"><i class="fa fa-refresh mr-1"></i> Rouvrir
            </b-button>
            <b-button v-if="!disableDeneutralisationTempoBPIJ" class="float-right mt-2 mb-1 mr-1" variant="warning"
                      @click="deneutraliseTempoBPIJ"><i class="fa fa-refresh mr-1"></i> Déneutraliser
            </b-button>
            <b-button class="float-right mt-2 mb-1 mr-1" variant="info" @click="initiateSave('next')"
                      :disabled="disableNextButton()"><i class="fa fa-save"></i> Dossier Suivant <i class="fa fa-arrow-right"></i>
            </b-button>
            <b-button v-if="showNextRelatedButton()" class="float-right mt-2 mb-1 mr-1" variant="success" @click="initiateSave('nextRelated')"
                      ><i class="fa fa-save"></i> Suivant du même Salarié <i class="fa fa-arrow-right"></i>
            </b-button>
            <b-button class="float-right mt-2 mb-1 mr-1" variant="secondary" @click="returnBack"><i
              class="fa fa-window-close"></i> Retour sans enregistrer
            </b-button>
            <b-button v-if="(getTypeDossier() === 'ij' || getTypeDossier() === 'inval')" :disabled="hasJournalDeces()" class="float-right mt-2 mb-1 mr-1" @click="initiateMailDeces()" style="color:#edeff1;background-color:#BB001E;border-color:#c8ced3;"><i class="fa fa-send"></i>
              Signaler décès
            </b-button>
          </fieldset>
        </div>
      </b-card>
    <b-modal scrollable id="modal-duplication" ref="modal-duplication" title="Dupliquer un dossier">
      <div>
        <div class="col-md-6">
          <input type="radio" name="duplication_type" id="pieces_jointes" v-model="typeDuplication"
                 value="pieces_jointes" checked/>
          <label for="pieces_jointes" class="ml-1">Duplication pièces jointes </label>
        </div>
        <div class="col-md-6">
          <input type="radio" name="duplication_type" id="dossier_salarie" v-model="typeDuplication"
                 value="dossier_salarie"/>
          <label for="dossier_salarie" class="ml-1">Duplication dossier salarié </label>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModal('modal-duplication')">Annuler</button>
          <button type="button" @click="save('duplicate')" class="btn btn-primary"><i class="fa fa-save"></i>
            Valider
          </button>
        </div>
      </template>
    </b-modal>
    <b-modal centered id="modal-reOpen" ref="modal-reOpen" title="Commentaire de réouverture">
      <label><b>Motif de réouverture</b></label>
      <b-form-select v-model="motifReopen" :options="motifReopenOptions" :class="{hasError: errors.motifReopen !== ''}">
      </b-form-select>
      <span class="field-error d-block mr-1 ">{{ errors.motifReopen }}</span>
      <b-form-textarea
        id="textarea"
        v-model="commentaireReopen"
        placeholder="Commentaire / Précision..."
        rows="3"
        max-rows="6"
        class="mt-2"
      ></b-form-textarea>
      <span class="field-error d-block mr-1 ">{{ errors.commentaireReopen }}</span>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModalReOpen()">Annuler</button>
          <button type="button" @click="reOpen" class="btn btn-warning"><i class="fa fa-save"></i>
            Rouvrir le dossier
          </button>
        </div>
      </template>
    </b-modal>
    <b-modal centered id="modal-resultat-motifAno" ref="modal-resultat-motifAno" title="Renseigner le résultat et le motif de l'anomalie" :dossier="dossier">
      <label><b>Résultat</b></label>
      <b-form-select v-model="resultatIncident" :options="currentTreatment.libelle_technique==='ij_expertise_presta_niv2' ? appuiExpertOptions : resultatsOptions" :class="{hasError: errors.resultatIncident !== ''}">
      </b-form-select>
      <span class="field-error d-block mr-1">{{ errors.resultatIncident }}</span>
      <label>
        <b v-if="currentTreatment.libelle_technique==='ij_expertise_presta_niv2'">Motif de sollicitation</b>
        <b v-else>Anomalie principale</b>
      </label>
      <b-form-select v-model="motifAnomalie" :options="computedResultat" :class="{hasError: errors.motifAnomalie !== ''}"
                     :disabled="resultatIncident === resultatOKId || currentTreatment.libelle_technique === 'ij_expertise_presta_niv2'">
      </b-form-select>
      <span v-if="errors.motifAnomalie !== ''" class="field-error d-block mr-1">{{ errors.motifAnomalie }}</span>
      <label><b>Commentaire</b></label>
      <b-form-textarea
        id="commentaire"
        type="text"
        rows="3"
        max-rows="9"
        v-model="commentaireControle">
      </b-form-textarea>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModalResultatAno()">Annuler</button>
          <button type="button" @click="validateDataResultat()" class="btn btn-warning"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" scrollable id="modal-dossiers-bloques" ref="modal-dossiers-bloques" title="Gestion des dossiers traités mais au paiement bloqué et des dossiers BPIJ">
      <b-row>
        <b-col sm=12>
          <p>
            Il y a plusieurs dossiers pour le même nir et même type qui sont traités sur NSI mais avec un paiement bloqué ou plusieurs dossiers BPIJ pour le même nir.<br>
            Vous pouvez changer le statut de certains ou de la totalité des dossiers, en les sélectionnant (case à cocher) et en indiquant le statut à leur mettre.<br>
            Vous pouvez également enregistrer le changement uniquement pour le dossier actuel (bouton orange).
          </p>
          <b-table striped hover :items="relatedBloquedDossiers" :fields="dossierBloqueFields">
            <template #head(checkboxBlockedDossier)="data">
              <b-form-checkbox
                v-model="allSelected"
                :indeterminate="indeterminate"
                aria-describedby="items"
                aria-controls="items"
                @change="toggleAll"
              >
              </b-form-checkbox>
            </template>
            <template #cell(canal)="data">
              {{ data.item.canal.libelle }}
            </template>
            <template #cell(date_debut_periode)="data">
              Du {{ shortFormatDate(data.item.date_debut_periode) }} au {{ shortFormatDate(data.item.date_fin_periode) }}
            </template>
            <template #cell(montant_ij_ss)="data">
              {{ data.item.montant_ij_ss }}
            </template>
            <template #cell(statusActuel)="data">
              {{ getStatusDossierBloque(data.item) }}
            </template>
            <template #cell(passageStatus)="data">
              <b-form-select id="statutActuel"
                         :plain="true"
                         :options="statusBloquedDossierOptions"
                         v-model="statusBloquedDossier[data.item.id]"
              >
              </b-form-select>
            </template>
            <template #cell(checkboxBlockedDossier)="data">
              <b-form-checkbox v-model="selectedBloquedDossier" :value="data.item.id" :state="errors.selectedBloquedDossier === ''"></b-form-checkbox>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <span v-if="errors.selectedBloquedDossier !== ''" class="float-right field-error d-block mr-1">{{ errors.selectedBloquedDossier }}</span>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModal('modal-dossiers-bloques')">Annuler</button>
          <button type="button" @click="saveBlockedDossier('ignore')" class="btn btn-warning mr-1"><i class="fa fa-save"></i> Enregistrer uniquement le dossier, ne pas toucher aux autres</button>
          <button type="button" @click="saveBlockedDossier('apply')" class="btn btn-primary"><i class="fa fa-save"></i> Valider</button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop hide-header-close title="Signalisation décès de l'assuré" id="modal-mail-signalisation-deces" ref="modal-mail-signalisation-deces">
      <b-form>
        <b-row>
          <b-col sm="1">
            <label for="mailTo">A :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="mailTo" type="text" v-model="mailTo" :class="{hasError: errors.mailTo !== ''}" disabled></b-form-input>
            <span class="field-error">{{ errors.mailTo }}</span>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="reponseCc">Cc :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="mailCc" type="text" v-model="mailCc"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="mailSubject">Objet :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="mailSubject" type="text" v-model="mailSubject" :class="{hasError: errors.mailSubject !== ''}" disabled></b-form-input>
            <span class="field-error">{{ errors.mailSubject }}</span>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="date_deces">Date du décès :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="date_deces" type="date" :max="maxDateDeces" @paste="onPaste($event)" v-model="date_deces" :class="{hasError: errors.date_deces !== ''}"></b-form-input>
            <span class="field-error">{{ errors.date_deces }}</span>
          </b-col>
        </b-row>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="sendMailDeces()">
            <i class="fa fa-paper-plane"></i>
            Envoyer
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="cancelMailDeces()">
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {getUser, getAccessToken, getBaseUrl, getIdToken, getProvider} from '@/utils/auth'
  import {espaceGestionRules as rules, hasRule, espaceQualiteRules} from "@/utils/rulesHelper"
  import { isResponsable as isResponsableEquipe, getUserTraitementIds, hasTraitement} from "@/utils/userHelper"
  import {fr} from 'vuejs-datepicker/dist/locale'
  import scrollBottom from "@/components/ScrollToBottom"
  // import qualificationTab from "@/components/Dossier/DossierQualificationTab"
  import DonneesSinistre from "@/components/Dossier/DetailsDossier/DonneesSinistre";
  import DroitAssure from "@/components/Dossier/DetailsDossier/DroitAssure";
  import CompletudeDossier from "@/components/Dossier/DetailsDossier/CompletudeDossier";
  import DonneesDbco from "@/components/Dossier/DetailsDossier/DonneesDbco";
  import PiecesJointes from "@/components/Dossier/DetailsDossier/PiecesJointes";
  import AideGestion from "@/components/Dossier/DetailsDossier/AideGestion";
  import Incidents from "@/components/Dossier/Incidents/Incidents";
  import Beneficiaires from "@/components/Dossier/Beneficiaires/Beneficiaires";
  import HistoriqueSinistres from "@/components/Dossier/HistoriqueSinistres/HistoriqueSinistres";
  import DecomptesIj from "@/components/Dossier/Decomptes/DecomptesIJ";
  import DecomptesDcInval from "@/components/Dossier/Decomptes/DecomptesDCInval";
  import DemandesClients from "@/components/Dossier/DemandesClients/DemandesClients";
  import Communications from "@/components/Dossier/Observation/Communications";
  import Controle from "@/components/Dossier/Qualite/Controle";
  import SuiviDossier from "@/components/Dossier/SuiviDossier/SuiviDossier";
  import Journal from "@/components/Dossier/Journal/Journal";
  import {CoolSelect as AutoSelect} from 'vue-cool-select';
  import {checkNIR, checkSIREN, isEmpty} from "@/utils/fileHelper";
  // import ControlePj from "@/components/Dossier/DetailsDossier/ControlePj";
  import {getMainTreatmentBasedOnType} from "@/utils/communHelper";
  import moment from 'moment';
  import JournalQualite from "@/components/Dossier/Journal/JournalQualite";
  import SalaireListing from "@/components/Dossier/Salaire/SalaireListing";
  import Salaire from "@/components/Dossier/Salaire/Salaire";
  import { formatDateTime, cantEditFicheDC } from "@/utils/communHelper";
  import loadingField from "@/components/LoadingField";

  export default {
    components: {
      SuiviDossier,
      // qualificationTab,
      DonneesSinistre,
      DroitAssure,
      CompletudeDossier,
      PiecesJointes,
      AideGestion,
      Incidents,
      HistoriqueSinistres,
      DecomptesIj,
      DecomptesDcInval,
      // DemandesClients,
      Communications,
      Controle,
      AutoSelect,
      Journal,
      scrollBottom,
      DonneesDbco,
      // ControlePj,
      JournalQualite,
      Beneficiaires,
      Salaire,
      SalaireListing,
      loadingField
    },
    data() {
      return {
        accessibleTabs: [],
        loadingComponent: false,
        visitedTabs: [],
        loadingHisto: true,
        loadingDecompte: true,
        loadingSalaire: true,
        loadingIncident: true,
        loadingJournal: true,
        loadingContact: true,
        loadingSalaireListing: true,
        nirIndisponible: false,
        sirenIndisponible: false,
        showFicheSiren: false,
        isTraitementQCTypeProduit: false,
        isTraitementQC: false,
        isAssureOpen: false,
        isAdherentTabOpen: false,
        isReadOnly: false,
        nir: '',
        nirWithoutKey: '',
        nom: '',
        prenom: '',
        nom_naissance: '',
        date_naissance: '',
        source_date_naissance: '',
        email: '',
        telephone: '',
        adresse1: '',
        adresse2: '',
        keyNir: '',
        ppNumber: '',
        pmNumber: '',
        raisonSociale: '',
        siren: '',
        nic:'',
        nirList: [],
        allSegments: [],
        selectedSegment: null,
        selectedSegmentLibelle: '',
        dt: '',
        oag: '',
        oap: '',
        statut_prestij: '',
        statut_prestij_libelle: '',
        sirhPartenaire: '',
        exportSirh: 'Non',
        declarantName: '',
        declarantMail: '',
        declarantTel: '',
        dossierId: '',
        dossier: {},
        dataSirens: [],
        dataIdpps: [],
        idppOptions: [],
        ppNumberApi: '',
        loadingIdppApi: false,
        nbIdpps: 1,
        selectedIdpp: '',
        idppApi: '',
        sirenPreference: {},
        garantie: '',
        date_du: '',
        date_au: '',
        numPsi: '',
        statutActuelLibelle: '',
        statutActuelLibelleTech: '',
        currentTreatment: {},
        dossierMainTreatment: {},
        statusBloquedDossier: {},
        relatedBloquedDossiers: [],
        hasRelatedBlocked: false,
        statusBloquedDossierOptions: [],
        selectedBloquedDossier: [],
        saveType: '',
        dossierBloqueFields: ['id', 'canal', {key: 'date_debut_periode', label: 'Période'}, {key: 'montant_ij_ss', label: 'Montant IJSS'}, {key: 'statusActuel', label: 'Statut actuel'}, {key: 'passageStatus', label: 'Passer au statut'}, {key: 'checkboxBlockedDossier', label: '#'}],
        errors: {
          date_au: '',
          date_du: '',
          montantIJSS: '',
          montantIJSSNet: '',
          id_pp: '',
          num_dossier: '',
          num_decompte: '',
          nir: '',
          keyNir: '',
          selectedType: '',
          selectedFamilleProduit: '',
          nirWithoutKey: '',
          nom: '',
          prenom: '',
          siren: '',
          raisonSociale: '',
          dateReception: '',
          dateReceptionCourrier: '',
          dateCourrierInitialisation: '',
          dateRepriseTempsComplet: '',
          dateSuspensionContrat: '',
          canal: '',
          mainTreatmentStatus: '',
          nom_naissance: '',
          date_naissance: '',
          email: '',
          telephone: '',
          adresse1: '',
          adresse2: '',
          dateSignature: '',
          selectedAccuseReception: '',
          selectedMotifsRejet: '',
          reponseDb: '',
          dbcoType: '',
          isConforme: '',
          dbcoUuid: '',
          yousignId: '',
          commentaireReopen: '',
          resultatIncident: '',
          motifAnomalie: '',
          mailTo: '',
          mailCc: '',
          mailSubject: '',
          date_deces: '',
          reponseBody: '',
          selectedBloquedDossier: '',
          motifReopen: '',
          dateInfoDeces: '',
          sourceInfo: '',
          clotureDeces: '',
          ppNumber: '',
          causeSinistreId: '',
        },
        fr: fr,
        DatePickerFormat: 'dd/MM/yyyy',
        timeoutId: null,
        loadingNir: false,
        loadingDossier: false,
        num_dossier: '',
        dossierList: [],
        noData: false,
        isTypeDc: false,
        isQualification: false,
        isDcPrestation: false,
        isIjValidationDossierPrestation: false,
        isIjGestionPrestation: false,
        isIjModulePrevoyance: false,
        isIjExpertisePresta: false,
        isIjCorrectionNsi: false,
        isIjCorrectionCotisations: false,
        isIjCorrectionContrat: false,
        isIjControleDossierPrestation: false,
        isEditRibPrestation: false,
        isAffiliation: false,
        isConformiteDBCO: false,
        isValidationConformiteDBCO: false,
        isQualitePrestation: false,
        finished: false,
        validNir: null,
        allStatus: [],
        statusTraite: {},
        statusTraiteIds: [],
        statusEnAttente: {},
        statusEnAttenteIds: [],
        statusNeutraliseIds: [],
        statusEnAttenteDpc: {},
        statusAAffecter: {},
        statusATraiter: {},
        statusATraiterIds: [],
        statusTraiteSupprime: {},
        statusRefusPriseEnCharge: {},
        statusTraiteNeutralise: {},
        statusDejaTraite: {},
        statusPassageManuel: {},
        statusAbandon: {},
        statusNeutraliseTemporisationId: '',
        selectedType: null,
        selectedFamilleProduit: null,
        allTypes: [],
        allTypesOption: [],
        allFamillesProduits: [],
        displayedData: {
          siren: '',
          nom: '',
          prenom: '',
          raisonSociale: '',
          nirWithoutKey: '',
          dateReception: '',
          nic: '',
        },
        user: {},
        typeDuplication: 'pieces_jointes',
        disableDuplication: true,
        disableReOpen: true,
        disableDeneutralisationTempoBPIJ: true,
        isEmpty,
        alerteMultipleDossier: '',
        allTraitements: [],
        noValidationRequired: false,
        verifyCheckBoxes: false,
        requiredFields: [],
        dateDebutSinistreIndisponible: false,
        isNotDbco: true,
        saveIncidentConformite: false,
        allMotifsRejet: [],
        exclusion_traitement_auto: false,
        commentaireReopen:'',
        motifReopen:'',
        resultatIncident: '',
        resultatsOptions: [],
        appuiExpertOptions: [],
        motifAnomalie: '',
        motifsAnomalieOptions: [],
        controleDossier: [],
        traitementControleId: null,
        resultatOKId: null,
        commentaireControle: '',
        typeUrgence: '',
        statusBasculeModulePrev: {},
        statusBasculeModulePrevBonIntegration: {},
        statusBonIntegrationNsi: {},
        allSelected: [],
        indeterminate: false,
        showCheckboxChangeContact: false,
        showDuplicateBtn: false,
        changementContact: 'unchanged',
        motifReopenOptions: [],
        ijListe: false,
        nbIjListe: '',
        mailTo: '',
        mailCc: '',
        mailSubject: '',
        date_deces: '',
        destinataires: '',
        maxDateDeces: '',
        backupTypeForMotifAno: '',
        groupSelectOption: {},
      };
    },
    watch: {
      dossier() {
        this.getLibelleStatus();
        // Gestion de la liste des dossiers pour le bouton suivant
        let seqDossiers = this.getSeqDossiers(this.$route.query.seqDossiers);

        if (!isEmpty(seqDossiers)) {
          seqDossiers.splice(0,seqDossiers.indexOf(this.dossier.id)+1);
        }
        this.$route.query.seqDossiers = seqDossiers;
        this.isReopenable();
        //this.isTemporisationBPIJ();
        if (this.isQualification || ((this.isConformiteDBCO && this.dossier.type_support === 'papier') || (this.isConformiteDBCO && this.dossier.typeSupport === 'papier'))) {
          this.isAssureOpen = true;
        }
        // On calcul s'il faut afficher la case à cocher pour le changement d'info de contact suite mnd ou pnd sur dossier DBCO
        let currentStatus = this.dossier.status.find(status => parseInt(status.pivot.traitement_id) === parseInt(this.$route.query.traitementId));
          // console.log('currentStatus',currentStatus)
        this.showCheckboxChangeContact = this.isConformiteDBCO && this.statusTraiteIds.indexOf(currentStatus.id) > -1 && this.dossier.accuse_reception === 'ar_mail';

        this.showDuplicateBtn = this.statutActuelLibelleTech !== 'a_traiter_duplication_ij_liste';

        this.isTypeDc = this.getTypeDossier() === 'dc' && this.hasTraitementDeces();

        if (!isEmpty(this.dossier) && !isEmpty(this.dossier.nir)) {
          this.getNumPpFromApi(this.dossier.nir);
        }
      },
      siren() {
        this.showFicheSiren = !isEmpty(this.siren) && checkSIREN(this.siren);
      },
      nic(){
        let fullNic = '';
        if (!isEmpty(this.nic)) {
          fullNic = this.nic.toString().padStart(5,'0');
        }
        
        if(this.siren && this.siren.length && fullNic.length === 5){
          this.getNumPm(this.siren + fullNic);
        }
      },
      nirWithoutKey(){
        if (!isEmpty(this.nirWithoutKey) && this.nirWithoutKey.length >= 13) {
          this.idppApi = '';
          this.getNumPpFromApi(this.nirWithoutKey);
        }else{
          this.idppApi = 'Veuillez compléter le NIR';
        }
      },
      exclusion_traitement_auto(value) {
        this.$event.emit('changeExclusion', value);
        this.$event.emit('changeAllocationObseques', value);
      },
      'errors.selectedType'(value){
        if(value !== '') {
          this.isTraitementQCTypeProduit = true;
        }
      },
      'errors.selectedFamilleProduit'(value){
        if(value !== '') {
          this.isTraitementQCTypeProduit = true;
        }
      },
      'errors.nirWithoutKey'(value){
        if(value !== '') {
          this.isAssureOpen = true;
        }
      },
      'errors.nom'(value){
        if(value !== '') {
          this.isAssureOpen = true;
        }
      },
      'errors.prenom'(value){
        if(value !== '') {
          this.isAssureOpen = true;
        }
      },
      'errors.ppNumber'(value){
        if(value !== '') {
          this.isAssureOpen = true;
        }
      },
      'errors.siren'(value){
        if(value !== '') {
          this.isAdherentTabOpen = true;
        }
      },
      'errors.raisonSociale'(value){
        if(value !== '') {
          this.isAdherentTabOpen = true;
        }
      },
      selectedBloquedDossier(newVal) {
        // Handle changes in individual checkboxes
        if (newVal.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newVal.length === this.relatedBloquedDossiers.length) {
          this.indeterminate = false
          this.allSelected = true
        } else {
          this.indeterminate = true
          this.allSelected = false
        }
      },
      changementContact() {
        this.$event.emit('changementContact',this.changementContact);
      },
      selectedIdpp() {
        this.ppNumber = this.selectedIdpp.split('-')[0];
        // On gère le SIREN associé à l'id_pp sélectionné
        this.manageSirenIdpp();
      },
    },
    computed: {
      adherentEmpty() {
        return isEmpty(this.siren) || isEmpty(this.raisonSociale);
      },
      computedClass() {
        let className = 'default-fiche-dossiers-tabs';
        if (this.dossier.type) {
          if (this.dossier.type.groupe.toLowerCase() === 'inval') {
            className = 'orange-fiche-dossiers-tabs';
          }
          if (this.dossier.type.groupe.toLowerCase() === 'dc') {
            className = 'blue-fiche-dossiers-tabs';
          }
          if (this.dossier.type.groupe.toLowerCase() === 'dbco') {
            className = 'green-fiche-dossiers-tabs';
          }
        }
        return className;
      },
      computedResultat() {
        if (this.resultatIncident === this.resultatOKId) {
          return null;
        }
        return this.motifsAnomalieOptions;
      },
    },
    async created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken();
      this.$axios.defaults.headers.common['Accept'] = 'application/json';
      this.$axios.defaults.headers.common['Provider'] = getProvider();
      this.dossierId = this.$route.params.id;

      this.getTypes();
      await this.getAllTraitements();
      this.user = getUser();
      await this.getAllStatusByType();
      await this.getDossier();
      this.getAccessibleTabs()
      this.getSegments();
      this.getResultats();
      
      this.getDestinataireRapport()
      this.setMaxDateDeces()

      this.$event.on('refreshDossier', () => {
        this.getDossier();
      });
      this.$event.on('editDossier', (component, data) => {
        if (component === 'DonneesSinistre') {
          this.getDonneesSinistre(data);
        }
        if (component === 'Controle') {
          this.getDonneesQualite(data);
        }
        // if (component === 'DemandesClients') {
        //   this.getDonneesDemandesClients(data);
        // }
        if (component === 'Communications') {
          this.getDonneesCommunications(data);
        }
        if (component === 'SuiviDossier') {
          this.getDonneesSuiviDossier(data);
        }
        if (component === 'Incidents') {
          this.getDonneesIncidents(data);
        }
        if (component === 'DonneesDbco') {
          this.getDonneesDbco(data);
        }
        if (component === 'DroitAssure') {
          this.getDonneesDroitAssure(data);
        }
        if (component === 'CompletudeDossier') {
          this.getDonneesCompletudeDossier(data);
        }
        if (component === 'salaire') {
          this.getDonneesSalaireDossier(data);
        }
      });
      this.$event.on('addIncident', () => {
        this.verifyBeforeSaveIncident();
      });
      this.isTypeDc = this.getTypeDossier() === 'dc' && this.hasTraitementDeces();
      //this.getDateNaissanceSource()
    },
    mounted() {
      this.getMotifRouverture();
      this.getFamillesProduits();
      this.$event.on('stopLoadingHisto', () => {
        let el = document.getElementById('spinner_tab_HistoriqueSinistres')
        if (!isEmpty(el)) {
          el.hidden = true
        }
      });
      this.$event.on('startLoadingDecompte', () => {
        this.loadingDecompte = true;
      });

      this.$event.on('stopLoadingDecompte', () => {
        let elDecompteIj = document.getElementById('spinner_tab_DecomptesIj')
        if (!isEmpty(elDecompteIj)) {
          elDecompteIj.hidden = true
        }
        let elDecompteDcInval = document.getElementById('spinner_tab_DecomptesDcInval')
        if (!isEmpty(elDecompteDcInval)) {
          elDecompteDcInval.hidden = true
        }
      });
      this.$event.on('stopLoadingSalaire', () => {
        let el = document.getElementById('spinner_tab_Salaire')
        if (!isEmpty(el)) {
          el.hidden = true
        }
      });
      this.$event.on('stopLoadingSalairesListing', () => {
        let el = document.getElementById('spinner_tab_SalaireListing')
        if (!isEmpty(el)) {
          el.hidden = true
        }
      });
      this.$event.on('stopLoadingIncident', () => {
        let el = document.getElementById('spinner_tab_Incidents')
        if (!isEmpty(el)) {
          el.hidden = true
        }
      });
      this.$event.on('stopLoadingJournal', () => {
        let el = document.getElementById('spinner_tab_Journal')
        if (!isEmpty(el)) {
          el.hidden = true
        }
      });
      this.$event.on('stopLoadingContact', () => {
        let el = document.getElementById('spinner_tab_Communications')
        if (!isEmpty(el)) {
          el.hidden = true
        }
      });
      if (this.isQualification || ((this.isConformiteDBCO && this.dossier.type_support === 'papier') || (this.isConformiteDBCO && this.dossier.typeSupport === 'papier'))) {
        this.isAssureOpen = true;
      }
      

      // console.log('this.isTypeDc',this.isTypeDc,this.getTypeDossier())
      
    },
    methods: {
      getAccessibleTabs() {
        let tabs = []
        if (this.isTypeDc) {
          tabs.push({
            title: 'Bénéficiaires',
            type: 'Beneficiaires',
            propsData: { dossier: this.dossier, traitements: this.allTraitements },
            loading: this.loadingBeneficiaire
          })
        }
        // Traitement : ij_module_prevoyance
        // Type : ijo
        // if (parseInt(this.$route.query.traitementId, 10) === this.getTraitementIdByLibelleTehnique('ij_module_prevoyance') && (this.dossier.type.libelle_technique === 'ijo')) {
          tabs.push({
            title: 'Elements de calculs',
            type: 'Salaire',
            propsData: { dossier: this.dossier },
            loading: this.loadingSalaire
          })
        // }
        // tabs.push({
        //   title: 'Salaires Listing',
        //   type: 'SalaireListing',
        //   propsData: { dossier: this.dossier },
        //   loading: this.loadingSalaireListing
        // })
        // tabs.push({
        //   title: 'Salaire',
        //   type: 'Salaire',
        //   propsData: { dossier: this.dossier }
        // })
        if (this.canAccessTab('incident')) {
          tabs.push({
            title: 'Incidents',
            type: 'Incidents',
            propsData: { dossier: this.dossier, traitements: this.allTraitements },
            loading: this.loadingIncident
          })
        }
        if (this.canAccessTab('histo')) {
          tabs.push({
            title: 'Histo sinistre',
            type: 'HistoriqueSinistres',
            propsData: { segments: this.allSegments, dossier: this.dossier, allTraitements: this.allTraitements },
            loading: this.loadingHisto
          })
        }
        if (this.canAccessTab('decompte-ij') && (this.getTypeDossier() === 'ij' || this.getTypeDossier() === '')) {
          tabs.push({
            title: 'Décomptes',
            type: 'DecomptesIj',
            propsData: { dossier: this.dossier, allStatus: this.allStatus },
            loading: this.loadingDecompte
          })
        }
        if (this.canAccessTab('decompte-dc') && (this.getTypeDossier() === 'dc' || this.getTypeDossier() === '')) {
          tabs.push({
            title: 'Décomptes',
            type: 'DecomptesDcInval',
            propsData: { dossier: this.dossier, allStatus: this.allStatus },
            loading: this.loadingDecompte
          })
        }
        if (this.canAccessTab('decompte-inval') && (this.getTypeDossier() === 'inval' || this.getTypeDossier() === '')) {
          tabs.push({
            title: 'Décomptes',
            type: 'DecomptesDcInval',
            propsData: { dossier: this.dossier, allStatus: this.allStatus },
            loading: this.loadingDecompte
          })
        }
        if (this.canAccessTab('observation')) {
          tabs.push({
            title: 'Contacts',
            type: 'Communications',
            propsData: { dossier: this.dossier, traitements: this.allTraitements },
            loading: this.loadingContact
          })
        }
        if (this.canAccessTab('journal')) {
          tabs.push({
            title: 'Journal',
            type: 'Journal',
            propsData: { dossier: this.dossier },
            loading: this.loadingJournal
          })
        }
        if (this.canAccessTab('qualite')) {
          tabs.push({
            title: 'Qualité',
            type: 'Controle',
            propsData: { dossier: this.dossier, traitements: this.allTraitements }
          })
        }
        if (this.canAccessTab('journalQualite')) {
          tabs.push({
            title: 'Journal qualité',
            type: 'JournalQualite',
            propsData: { dossier: this.dossier, traitemens: this.allTraitements }
          })
        }
        this.accessibleTabs = tabs
      },
      afficheSourceDateNaissance() {

        if (this.dossier.date_naissance && this.dossier.canal && this.dossier.canal.libelle_technique === 'cev') {
            this.source_date_naissance = 'Source de la donnée : CEV';
        }else if(this.dossier.date_naissance){
          this.source_date_naissance = 'Source de la donnée : NSI';
        }else{
          this.source_date_naissance = 'Source de la donnée : N/D';
        }

        return this.source_date_naissance;
      },
      formatDate(textDate) {
        let formattedDate = null;
        if (!isEmpty(textDate) && textDate !== 'Invalid date') {
          let date = new Date(textDate).toLocaleDateString("fr-FR").split('/');
          formattedDate = `${date[2]}-${date[1]}-${date[0]}`;
        }
        return formattedDate;
      },
      onPaste(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        let clipboardData = evt.clipboardData || window.clipboardData;
        let pastedData = clipboardData.getData('Text');
        pastedData = moment(pastedData, 'DD/MM/YYYY').format('YYYY-MM-DD');

        let today = new Date();
        let dateToCompare = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        dateToCompare = this.formatDateJs(dateToCompare).toString()

        this.maxDateDeces = this.formatDate(pastedData);
        if (this.maxDateDeces > dateToCompare) {
          this.errors.date_deces = 'Saisissez une date antérieure à la date du jour';
        } else {
          this.errors.date_deces = ''
        }
      },
      formatDateJs(textDate) {
        let date = textDate !== null ? moment(textDate).format('YYYY-MM-DD') : "-";
        return date;
      },
      setMaxDateDeces() {
        let today = new Date();
        this.maxDateDeces = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        this.maxDateDeces = this.formatDateJs(this.maxDateDeces).toString()
        // console.log(this.maxDateDeces)
      },
      // showDossierNumber() {
      //   // console.log(this.ijListe)
      // },
      onInput(value) {
        if(!this.visitedTabs.includes(value)){
          this.visitedTabs.push(value);

          if (this.isTypeDc && value === 1) {
            this.loadingBeneficiaire = false;
          }
          else if ((!this.isTypeDc && value === 3) || (this.isTypeDc && value === 4)) {
            this.loadingHisto = true;
          }
          else if ((!this.isTypeDc && value === 4) || (this.isTypeDc && value === 5)) {
            this.loadingDecompte = true;
          }
          else if ((!this.isTypeDc && value === 2) || (this.isTypeDc && value === 3)) {
            this.loadingIncident = true;
          } else if ((!this.isTypeDc && value === 6) || (this.isTypeDc && value === 7)) {
            this.loadingJournal = true;
          }
          else if ((!this.isTypeDc && value === 1) || (this.isTypeDc && value === 2)) {
            this.loadingSalaire = true;
          }
        }
      },
      canChangePrioritaire() {
        return hasRule(rules.CAN_SET_DOSSIER_URGENT) || this.isResponsable();
      },
      canAccessTab(tab) {
        let isPfe = hasTraitement('qualification_courrier');
        switch (tab) {
          case 'incident':
            return hasRule(rules.CAN_ACCESS_INCIDENT_TAB) || isPfe;
            // break;
          case 'histo':
            return hasRule(rules.CAN_ACCESS_HISTO_TAB) || isPfe;
            // break;
          case 'decompte-ij':
            return hasRule(rules.CAN_ACCESS_DECOMPTE_IJ) || ((isPfe && this.getTypeDossier() === 'ij') || (isPfe && this.getTypeDossier() === ''));
            // break;
          case 'decompte-dc':
            return hasRule(rules.CAN_ACCESS_DECOMPTE_DC) && this.getTypeDossier() === 'dc' || (isPfe && this.getTypeDossier() === 'dc');
            // break;
          case 'decompte-inval':
            return hasRule(rules.CAN_ACCESS_DECOMPTE_INVAL) && this.getTypeDossier() === 'inval' || (isPfe && this.getTypeDossier() === 'inval');
            // break;
          case 'observation':
            return hasRule(rules.CAN_ACCESS_OBSERVATION_TAB) || isPfe;
            // break;
          case 'qualite':
            return hasRule(espaceQualiteRules.MANAGE_CONTROLE_QUALITE);
            // break;
          case 'journalQualite':
            return hasRule(espaceQualiteRules.MANAGE_CONTROLE_QUALITE);
            // break;
          case 'journal':
            return hasRule(rules.CAN_ACCESS_JOURNAL_TAB) || isPfe;
            // break;
          case 'aide':
            return hasRule(rules.CAN_ACCESS_BLOCK_HELP) || isPfe;
            // break;
          default :
            return true;
        }
      },
      checkDossierType() {
        let dossierType = ""
        if (!isEmpty(this.dossier.type)) {
          if (this.dossier.type.groupe === 'IJ') {
            dossierType = 'ij'
          }
          else if (this.dossier.type.groupe === 'Inval') {
            dossierType = 'inval'
          }
          else if (this.dossier.type.groupe === 'DC') {
            dossierType = 'dc'
          }
        }
        return dossierType
      },
      isDisabled(field) {
        // TODO : ajouter un droit "Peut traiter n'importe quel dossier" pour les profils responsable de service, super admin et admin DGP
        // et ajouter !gestionnaireOk && (!this.isResponsable() || !hasRule('can_manage_all_dossier'))
        let isDisabled = false
        if (this.dossier && this.dossier.status) {
          for (let status of this.dossier.status) {
            if (parseInt(status.pivot.traitement_id,10) === parseInt(this.$route.query.traitementId,10)
                && (
                    this.statusTraiteIds.indexOf(status.id) > -1
                    || status.id === this.statusTraiteSupprime.id
                    || (this.statusNeutraliseIds.indexOf(status.id) > -1 && (this.isConformiteDBCO || this.isValidationConformiteDBCO)))
                ) {
              isDisabled = true
            }
          }
        }
        // console.log('isDisabled',field + ' -> ' + isDisabled)
        // On regarde si l'utilisateur possède le traitement actuel
        let userTraitementIds = getUserTraitementIds();

        if (userTraitementIds.indexOf(parseInt(this.$route.query.traitementId, 10)) === -1) {
          if (isEmpty(this.dossier.type) || (!isEmpty(this.dossier.type) && this.dossier.type.libelle_technique != 'invja')) {
            isDisabled = true
          } else if (userTraitementIds.length === 0) {
            isDisabled = true
          }
        }

        if (this.dossier && this.dossier.gestionnaires) {
          let gestionnaireOk = false
          for (let gestionnaire of this.dossier.gestionnaires) {
            if (gestionnaire.pivot.traitement_id === parseInt(this.$route.query.traitementId, 10)) {
              if (this.user.id === gestionnaire.id) {
                gestionnaireOk = true
              }
            }
          }
          if (!gestionnaireOk && !this.isResponsable()) {
            isDisabled = true
          }
        }
        if (field === 'selectedFlag') {
          isDisabled = false;
        }
        if (field === 'nirSearch' && !this.isQualification) {
          isDisabled = true;
        } else if ((field === 'nirWithoutKey' || field === 'keyNir' || field === 'ppNumber' || field === 'nom' || field === 'prenom')
          && (this.isIjValidationDossierPrestation || this.isEditRibPrestation)) {
          isDisabled = true;
        }
        if (field === 'produitQC' && this.isQualification) {
          // isDisabled = false;
        } else if ((field === 'raisonSociale' || field === 'siren' || field === 'selectedSegment' || field === 'selectedType') && (this.isIjValidationDossierPrestation)) {
          isDisabled = true;
        } else if (field === 'dt' || field === 'statut_prestij' || field === 'sirhPartenaire' || field === 'exportSirh') {
          isDisabled = true;
        } else if (field === 'declarantName' || field === 'declarantMail' || field === 'declarantTel') {
          // isDisabled false;
        } else if (field === 'accuseReception' && this.dossier.type_support === 'email' && !isEmpty(this.dossier.accuse_reception)) {
          isDisabled = true;
        } else if (field === 'yousignId' && ((this.dossier.type_support === 'email' && !isEmpty(this.dossier.yousign_id)) || this.dossier.type_support === 'papier')) {
          isDisabled = true;
        } else if (field === 'dateSignature' && this.dossier.type_support === 'email') {
          isDisabled = true;
        } else if (field === 'dateReception') {
          isDisabled = true;
        } else if (field === 'dateReceptionCourrier') {
          if (this.dossier.canal && this.dossier.canal.libelle_technique === 'cev') {
            isDisabled = true;
          }
        } else if (field === 'dbcoUuid') {
          isDisabled = true;
        } else if (field === 'exclusion_traitement_auto' && this.isIjModulePrevoyance) {
          isDisabled = true;
        } else if (this.isQualitePrestation) {
            if (!isEmpty(this.dossier.incidents)) {
              let treatment = this.user.profil_active[0].traitements.find( (element) => element.id === parseInt(this.$route.query.traitementId,10) );
              // let treatment = _.find(this.user.profil_active[0].traitements, (element) => element.id === parseInt(this.$route.query.traitementId,10) );
              if (isEmpty(treatment)) {
                isDisabled = true;
              } else {
                isDisabled = !(treatment.categorie.toLowerCase() === 'controle' && treatment.type.toLowerCase() === 'principal');
              }
            }
        } else if (this.isConformiteDBCO || this.isValidationConformiteDBCO) {
          // console.log('dans isDisabled',)
          if (this.isConformiteDBCO && field === 'status') {
            if (!isEmpty(this.dossier.incidents) && parseInt(this.dossier.incidents[0].sous_status_id,10) === parseInt(this.getStatusIdByLibelleTehnique('en_attente_validation_dbco')))
            isDisabled = true;
          }else if (field === 'dbcoType' && this.dossier.type_support === 'email' && !isEmpty(this.dossier.dbco_type)) {
            isDisabled = true;
          }  else if (field === 'reponseDb' && this.dossier.type_support === 'email' && !isEmpty(this.dossier.dbco_reponse)) {
            isDisabled = true;
          } else if ((field === 'nirWithoutKey' || field === 'keyNir') && this.dossier.type_support === 'email' && !isEmpty(this.dossier.nir)) {
            isDisabled = true;
          } else if (field === 'nom' && this.dossier.type_support === 'email' && !isEmpty(this.dossier.nom)) {
            isDisabled = true;
          } else if (field === 'nom_naissance' && this.dossier.type_support === 'email' && !isEmpty(this.dossier.nom_naissance)) {
            isDisabled = true;
          } else if (field === 'prenom' && this.dossier.type_support === 'email' && !isEmpty(this.dossier.prenom)) {
            isDisabled = true;
          } else if (field === 'ppNumber' && this.dossier.type_support === 'email' && !isEmpty(this.dossier.id_pp)) {
            isDisabled = true;
          } else if (field === 'selectedType') {
            isDisabled = true;
          } else if (field === 'email') {
            isDisabled = false;
          } else if (field === 'date_naissance' && this.dossier.type_support === 'email' && !isEmpty(this.dossier.date_naissance)) {
            isDisabled = true;
          } else if (field === 'telephone' && this.dossier.type_support === 'email' && !isEmpty(this.dossier.telephone)) {
            isDisabled = true;
          } else if (field === 'adresse1') {
            isDisabled = false;
          } else if (field === 'adresse2') {
            isDisabled = false;
          } else if (field === 'siren' && this.dossier.type_support === 'email' && !isEmpty(this.dossier.siren)) {
            isDisabled = true;
          } else if (field === 'typeSupport' && !isEmpty(this.dossier.type_support)) {
            isDisabled = true;
          }

        }

        // return field === 'nirSearch' ? true : false;
        return isDisabled;
      },
      isResponsable() {
        let isResponsable = isResponsableEquipe();

        return isResponsable
      },
      onClick(event, item, typeInput) {
        if (typeInput == 'beneficiaire') {
          // Infos bénéficiaire
          this.nirWithoutKey = this.getNirWithoutKey(item.nir);
          this.keyNir = this.getNirKey(item.nir);
          this.ppNumber = item.id_pp;
          this.nom = item.nom;
          this.prenom = item.prenom;
          this.date_naissance = item.date_naissance;
          this.email = item.email;
          this.telephone = item.numero_tel;
          // Infos Adhérent
          this.raisonSociale = item.raison_sociale;
          this.siren = item.siret.substring(0, 9);
          this.nic = item.siret.substring(9, 15);
          this.sirhPartenaire = item.sirh;
          // this.oag = item.siren.oag;
          this.selectedSegment = item.segment_gestion_id;
          // this.selectedSegmentLibelle = item.siren.preference.segment_gestion.libelle;
          // this.statut_prestij_libelle = item.siren.preference.statut_prestij.libelle;
          this.statut_prestij = item.statut_prestij_id;
          this.selectedFamilleProduit = item.famille_produit_id;
          this.nir = ''
          this.pmNumber = item.id_pm
        } else {
          this.nom = item.nom;
          this.prenom = item.prenom;
          this.ppNumber = item.id_pp;
          this.date_naissance = item.date_naissance;
          this.raisonSociale = item.siren.raison_sociale;
          this.nirWithoutKey = this.getNirWithoutKey(item.nir);
          this.keyNir = this.getNirKey(item.nir);
          this.siren = item.siren.siren;
          this.sirhPartenaire = item.sirh;
          this.oag = item.siren.oag;
          this.selectedSegment = item.siren.preference.segment_gestion.id;
          this.selectedSegmentLibelle = item.siren.preference.segment_gestion.libelle;
          this.statut_prestij_libelle = item.siren.preference.statut_prestij.libelle;
          this.statut_prestij = item.siren.preference.statut_prestij.id;
          this.selectedFamilleProduit = item.famille_produit_id;
          this.num_dossier = ''
          this.pmNumber = !isEmpty(item.id_pm) ? item.id_pm : null
          this.nic = !isEmpty(item.nic) ? item.nic : null
        }
      },
      onEnter(typeList) {
        if (typeList == 'nirList') {
          for (let item of this.nirList) {
            if (this.nir === item.id) {
              this.onClick(null, item)
            }
          }
        }
        if (typeList == 'dossierList') {
          for (let item of this.dossierList) {
            if (this.dossier === item.id) {
              this.onClick(null, item)
            }
          }
        }
      },
      raz() {
        this.nom = '';
        this.prenom = '';
        this.ppNumber = '';
        this.pmNumber = '';
        this.ppNumberApi = '';
        this.raisonSociale = '';
        this.nirWithoutKey = '';
        this.keyNir = '';
        this.siren = '';
        this.nic = '';
        this.sirhPartenaire = '';
        this.oag = '';
        this.oap = '';
        this.selectedSegment = '';
        this.selectedSegmentLibelle = '';
        this.statut_prestij_libelle = '';
        this.statut_prestij = '';
        this.selectedFamilleProduit = '';
        this.nir = '';
        this.nirList = [];
        this.nom_naissance = '';
        this.date_naissance= '';
        this.email= '';
        this.telephone= '';
        this.adresse1= '';
        this.adresse2= '';
        this.num_dossier= '';
      },
      async onSearchNir(search) {
        let self = this;
        const lettersLimit = 5;
        this.noData = false;
        if (search.length < lettersLimit) {
          this.gestionnaires = [];
          this.loadingNir = false;
          return
        }
        if(search.length === 13){
          this.nirWithoutKey = search;
        }
        this.loadingNir = true;
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(async () => {
          this.$axios
            .get(`/espaceGestion/nir/autocompleteRecherche?query=${search}`)
            .then(response => {
              // console.log('autocomplete data', response.data.data)
              this.loadingNir = false;
              this.nirList = response.data.data;
              this.noData = this.nirList.length === 0;
            })
            .catch(function (error) {
              // console.log(error);
              self.loadingNir = false;
              self.handleError(error);
            })
        }, 500)
      },
      async onSearchDossier(search) {
        let self = this;
        const lettersLimit = 5;
        this.noData = false;
        if (search.length < lettersLimit) {
          this.gestionnaires = [];
          this.loadingDossier = false;
          return
        }
        this.loadingDossier = true;
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(async () => {
          this.$axios
            .get(`/espaceGestion/dossier/autocompleteRecherche?query=${search}`)
            .then(response => {
              this.loadingDossier = false;
              this.dossierList = response.data.data;
              this.noData = this.dossierList.length === 0;
            })
            .catch(function (error) {
              // console.log(error);
              self.loadingDossier = false;
              self.handleError(error);
            })
        }, 500)
      },
      getDossier() {
        return new Promise(resolve => {
          let self = this;
          this.$store.commit("IS_LOADING", true);
          this.$axios
            .get("/espaceGestion/dossier/show/" + this.dossierId + '/' + this.$route.query.traitementId)
            .then(response => {
              this.$store.commit("IS_LOADING", false);
              this.dossier = response.data.dossier;
              this.beneficiaire = response.data.beneficiaire;
              this.dataSirens = response.data.dataSirens;
              this.dataIdpps = response.data.dataIdpps;
              // Il faut isolé les id_pp unique, car en cas de multi-siren, on aura focément plusieurs lignes d'id_pp (un par siren), ce qui ne veut pas dire qu'il y a forcément un doublon d'id_pp
              this.nbIdpps = [...new Set(response.data.dataIdpps.map(row => row.id_pp))].length;
              // console.log('this.nbIdpps',this.nbIdpps)
              for (let data of response.data.dataIdpps) {
                this.idppOptions.push({text: data.id_pp + ' (' + data.siren + ')', value: data.id_pp + '-' + data.siren});
              }
              this.sirenPreference = response.data.sirenPreference;

              this.alerteMultipleDossier = response.data.alerte;
              this.$store.dispatch('setSelectedDossier', this.dossier);
              this.finished = true;
              this.setForm(this.dossier, this.beneficiaire, response.data.sirenPreference);
              // On calcul le traitement principal du dossier
              this.dossierMainTreatment = this.getDossierTraitementByType();
              this.isReopenable();
              this.isTemporisationBPIJ();
              if (isEmpty(this.$route.query.seqRelatedDossiers) || isEmpty(response.data.relatedDossiersIds)) {
                this.$route.query['seqRelatedDossiers'] = response.data.relatedDossiersIds;
              } else if (this.$route.query.lastRelated && parseInt(this.$route.query.lastRelated,10) !== parseInt(this.dossier.id,10)) {
                this.$route.query['seqRelatedDossiers'] = response.data.relatedDossiersIds;
                this.$route.query.lastRelated = null;
              }
              // On récupère les dossiers relatifs en paiement bloqué
              this.relatedBloquedDossiers = response.data.relatedBloquedDossiers;
              this.hasRelatedBlocked = response.data.hasRelatedBlocked;
              resolve()
            })
            .catch((error) => {
              // console.log(error)
              self.handleError(error);
              resolve()
            });
        })
      
      },
      setForm(dossier, beneficiaire, sirenPreference) {

        this.nirWithoutKey = this.getNirWithoutKey(dossier.nir);
        this.keyNir = this.getNirKey(dossier.nir);
        this.ppNumber = dossier.id_pp;
        this.numPsi = dossier.numero_psi;
        this.nom = dossier.nom;
        this.prenom = dossier.prenom;
        this.nom_naissance = dossier.nom_naissance;
        this.date_naissance = dossier.date_naissance; //this.shortFormatDate(dossier.date_naissance);
        this.email = dossier.email;
        this.telephone = dossier.telephone;
        this.adresse1 = dossier.adresse1;
        this.adresse2 = dossier.adresse2;
        this.siren = dossier.siren;
        this.nic = dossier.nic;

        // this.raisonSociale = dossier.raison_sociale;
        this.raisonSociale = !isEmpty(dossier.siren_entity) ? dossier.siren_entity.raison_sociale : dossier.raison_sociale;
        this.selectedSegment = sirenPreference && sirenPreference.segment_gestion_id ? sirenPreference.segment_gestion_id : '';
        this.pmNumber = dossier.id_pm;

        this.selectedSegmentLibelle = sirenPreference && sirenPreference.segment_gestion ? sirenPreference.segment_gestion.libelle : '';
        this.declarantName = dossier.contact_nom ? dossier.contact_nom : dossier.nom_declarant_sinistre;
        this.declarantMail = dossier.contact_email ? dossier.contact_email : dossier.mail_declarant_sinistre;
        this.declarantTel = dossier.contact_tel ? dossier.contact_tel : dossier.tel_declarant_sinistre;
        this.statut_prestij = sirenPreference ? sirenPreference.status_prestij_id : '';
        this.statut_prestij_libelle = sirenPreference && sirenPreference.statut_prestij ? sirenPreference.statut_prestij.libelle : '';
        this.sirhPartenaire = sirenPreference ? sirenPreference.sirh_partenaire : '';
        this.exportSirh = sirenPreference && sirenPreference.sirh_export ? 'Oui' : 'Non';
        this.selectedType = dossier.type_id;
        this.selectedFamilleProduit = dossier.famille_produit_id;
        this.oag = dossier.oag;
        this.oap = dossier.oap;
        let dateConnexionValue = null;
        let emailBeneficiaireValue = null;
        let isBeneficiaireActifValue = false;
        if(!isEmpty(beneficiaire) && !isEmpty(beneficiaire.login)){
          emailBeneficiaireValue = beneficiaire.login.email;
          isBeneficiaireActifValue = beneficiaire.login.active;
          if(!isEmpty(beneficiaire.login.date_connexion)){
            dateConnexionValue = this.getFormattedDateTime(beneficiaire.login.date_connexion, '/');
          }
        }
        this.displayedData = {
          siren: !isEmpty(dossier.siren) ? dossier.siren : '',
          nic: !isEmpty(dossier.nic) ? dossier.nic : '',
          nom: !isEmpty(dossier.nom) ? dossier.nom.toUpperCase() : (dossier.nom_naissance ? dossier.nom_naissance.toUpperCase() : null),
          prenom: dossier.prenom ? dossier.prenom.slice(0, 1).toUpperCase() + dossier.prenom.slice(1).toLowerCase() : null,
          raisonSociale: !isEmpty(dossier.siren_entity) ? dossier.siren_entity.raison_sociale : dossier.raison_sociale,
          nirWithoutKey: this.getNirWithoutKey(dossier.nir),
          dateReception: this.shortFormatDate(dossier.date_reception),
          dateConnexion: dateConnexionValue,
          emailBeneficiaire : emailBeneficiaireValue,
          isBeneficiaireActif : isBeneficiaireActifValue,

        };
        // console.log('this.displayedData',this.displayedData);
        this.isNotDbco = !isEmpty(dossier.type) ? dossier.type.libelle_technique !== 'dbco' : true;
        //this.exclusion_traitement_auto = dossier.is_exclude_traitement_auto ? 'exclusion' : false;
        // Précochage Type Urgence en Urgences Directions si le canal est Urgences Directions en traitement PFE
        if (this.isQualification) {
          if (dossier.canal.libelle_technique == 'urgences_directions' && isEmpty(dossier.type_urgence)) {
            this.typeUrgence = 'urgences_directions';
          } else {
            this.typeUrgence = !isEmpty(dossier.type_urgence) ? dossier.type_urgence : '';
          }
        } else {
          this.typeUrgence = !isEmpty(dossier.type_urgence) ? dossier.type_urgence : '';
        }
      },
      canControl() {
        return true
      },
      canQualify() {
        return hasRule(rules.CAN_QUALIFY_DOSSIER)
      },
      canReopen(){
       return hasRule(rules.CAN_REOPEN_DOSSIER)
      },
      canManage() {
        return hasRule(rules.CAN_MANAGE_DOSSIER)
      },
      // validateData() {
      //   this.clearErrors()
      //   let regNumeric = this.$store.getters.getRegNumeric
      //   let valid = true;
      //   return valid;
      // },
      returnBack() {
        this.$router.push({
          path: "/espace-gestion/dossier",
          query: this.$route.query
        })
      },
      returnBackCampagne() {
        this.$router.push({
          path: '/espace-qualite/controle-qualite/campagnes-actives',
          query: {
            campagneId: parseInt(this.$route.query.campagneId),
            statusId: !isEmpty(this.$route.query.statutControleId) ? parseInt(this.$route.query.statutControleId) : null,
          }
        });
      },
      setNicFromIncident(nic){
        this.nic = nic;
      },
      getNumPm(siret){
        // let self = this;
        let dataPost = {
          siret: siret
        }
        this.$axios
          .post('/referentielClient/siret/getNumPm', dataPost)
          .then(response => {
              if((response.data.numPm)){
                this.pmNumber = response.data.numPm;
              }
          })
          .catch((error) => {
            // if(error.response.status === 404){

            // }
          });
      },
      clearErrors() {
        this.errors.date_du = '';
        this.errors.date_au = ''
        this.errors.montantIJSS = '';
        this.errors.montantIJSSNet = '';
        this.errors.id_pp = ''
        this.errors.num_dossier = ''
        this.errors.num_decompte = ''
        this.errors.nir = '';
        this.errors.keyNir = '';
        this.errors.selectedType = '';
        this.errors.selectedFamilleProduit = '';
        this.errors.nirWithoutKey = '';
        this.errors.nom = '';
        this.errors.prenom = '';
        this.errors.siren = '';
        this.errors.nic = '';
        this.errors.raisonSociale = '';
        this.errors.dateReception = '';
        this.errors.dateReceptionCourrier = '';
        this.errors.dateCourrierInitialisation = '';
        this.errors.dateRepriseComplet = '';
        this.errors.dateSuspensionContrat = '';
        this.errors.canal = '';
        this.errors.dateFaitGenerateur = '';
        this.errors.datePam = '';
        this.errors.dateEffet = '';
        this.errors.dateDeces = '';
        this.errors.typeDeces = '';
        this.errors.categorieInval = '';
        this.errors.taux = '';
        this.errors.capitalDeces = '';
        this.errors.typeRente = '';
        this.errors.mainTreatmentStatus = '';
        this.errors.nom_naissance = '';
        this.errors.date_naissance = '';
        this.errors.email = '';
        this.errors.telephone = '';
        this.errors.adresse1 = '';
        this.errors.adresse2 = '';
        this.errors.dateSignature = '';
        this.errors.selectedAccuseReception = '';
        this.errors.selectedMotifsRejet = '';
        this.errors.reponseDb = '';
        this.errors.dbcoType = '';
        this.errors.isConforme = '';
        this.errors.dbcoUuid = '';
        this.errors.yousignId = '';
        this.errors.commentaireReopen = '';
        this.errors.resultatIncident = '';
        this.errors.motifAnomalie = '';
        this.errors.selectedBloquedDossier = '';
        this.errors.motifReopen = '';
        this.errors.date_deces = '';
        this.errors.reponseBody = '';
        this.errors.dateInfoDeces = '';
        this.errors.sourceInfo = '';
        this.errors.clotureDeces = '';
        this.errors.numEvenementNsi = '';
      },
      clearForm() {
        this.date_du = ''
        this.date_au = ''
        this.id_pp = ''
        this.num_dossier = ''
        this.num_decompte = ''
        this.nir = ''
        this.nom = ''
        this.prenom = ''
      },
      getNirWithoutKey(nir) {
        let value = nir ? nir : '';
        if (value.length === 15) {
          value = nir.substring(0, 13);
        } else if (value.length === 14) {
          value += '0';
          value = value.substring(0, 13)
        }
        return value;
      },
      getNirKey(nir) {
        let value = nir ? nir : '';
        if (value.length === 15) {
          value = nir.substring(13);
        } else if (value.length === 14) {
          value += '0';
          value = value.substring(13)
        } else {
          value = '';
        }
        return value;
      },
      getSegments() {
        let self = this;
        // this.$store.commit("IS_LOADING", true)
        this.$axios
          .get("/espaceGestion/dossier/getAllSegment")
          .then(response => {
            // this.$store.commit("IS_LOADING", false);
            for (let segment of response.data.data) {
              this.allSegments.push({value: segment.id, text: segment.libelle});
            }
          })
          .catch((error) => {
            // console.log(error)
            self.handleError(error);
          })
      },
      getTraitementLibelleById() {
        return new Promise((resolve) => {
          let libelle_technique = this.allTraitements.reduce((res, treatment) => treatment.id === parseInt(this.$route.query.traitementId,10) ? treatment.libelle_technique : res,'');

          this.isQualification = libelle_technique === 'qualification_courrier';
          this.isDcPrestation = libelle_technique === 'gestion_dc';
          this.isIjValidationDossierPrestation = libelle_technique === 'ij_validation_dossier_prestation';
          this.isIjGestionPrestation = libelle_technique === 'ij_gestion_prestation';
          this.isIjModulePrevoyance = libelle_technique === 'ij_module_prevoyance';
          this.isIjExpertisePresta = libelle_technique === 'ij_expertise_presta';
          this.isIjCorrectionNsi = libelle_technique === 'ij_correction_nsi';
          this.isIjCorrectionCotisations = libelle_technique === 'ij_correction_cotisations';
          this.isIjCorrectionContrat = libelle_technique === 'ij_correction_contrat';
          this.isIjControleDossierPrestation = libelle_technique === 'ij_controle_dossier_prestation';
          this.isEditRibPrestation = libelle_technique === 'edit_rib_prestation';
          this.isAffiliation = libelle_technique === 'affiliation';
          this.isConformiteDBCO = libelle_technique === 'gestion_dbco';
          this.isValidationConformiteDBCO = libelle_technique === 'validation_dbco';
          this.isQualitePrestation = libelle_technique === 'ij_qualite_prestation';
          resolve();
        })

      },
      getAllStatusByType() {

        return new Promise((resolve) => {

          let self = this;
          let data = {
            libelle_categorie: 'status_dossier'
          }
          // this.$store.commit("IS_LOADING", true);
          this.$axios
            .post("/administration/status/allStatutsByType", data)
            .then(response => {
              // this.$store.commit("IS_LOADING", false);
              this.allStatus = response.data.allStatus;
              this.statusTraite = response.data.statusTraite;
              this.statusTraiteIds = this.statusTraite.sous_statuts.map((item) => item.id)
              this.statusTraiteIds.push(this.statusTraite.id)
              let statusDejaTraite = response.data.statusTraite.sous_statuts.reduce((res,status) => {
                return status.libelle_technique === 'deja_traite' ? status : res;
              },{});
              this.statusDejaTraite = statusDejaTraite;
              let statusPassageManuel = response.data.statusTraite.sous_statuts.reduce((res,status) => {
                return status.libelle_technique === 'traite_bascule_saisie_manuelle' ? status : res;
              },{});
              this.statusPassageManuel = statusPassageManuel;

              let statusBasculeModulePrev = response.data.statusTraite.sous_statuts.reduce((res,status) => {
                return status.libelle_technique === 'traite_passage_module_prevoyance' ? status : res;
              },{});
              this.statusBasculeModulePrev = statusBasculeModulePrev;

              let statusBasculeModulePrevBonIntegration = response.data.statusTraite.sous_statuts.reduce((res,status) => {
                return status.libelle_technique === 'traite_passage_module_prevoyance_bon_integration' ? status : res;
              },{});
              this.statusBasculeModulePrevBonIntegration = statusBasculeModulePrevBonIntegration;

              let statusAbandon = response.data.statusTraite.sous_statuts.reduce((res,status) => {
                return status.libelle_technique === 'traite_dpc_sans_reponse' ? status : res;
              },{});
              this.statusAbandon = statusAbandon;
              let statusTraiteSupprime = response.data.statusTraite.sous_statuts.reduce((res,status) => {
                return status.libelle_technique === 'traite_supprime' ? status : res;
              },{});
              this.statusTraiteSupprime = statusTraiteSupprime;

              let statusRefusPriseEnCharge = response.data.statusTraite.sous_statuts.reduce((res,status) => {
                return status.libelle_technique === 'traite_refus_pec' ? status : res;
              },{});
              this.statusRefusPriseEnCharge = statusRefusPriseEnCharge;

              this.statusEnAttente = response.data.statusEnAttente
              this.statusEnAttenteIds = this.statusEnAttente.sous_statuts.map((item) => item.id)
              this.statusEnAttenteIds.push(this.statusEnAttente.id)
              let statusEnAttenteDpc = response.data.statusEnAttente.sous_statuts.reduce((res,status) => {
                return status.libelle_technique === 'en_attente_dpc' ? status : res;
              },{});
              this.statusEnAttenteDpc = statusEnAttenteDpc;

              // console.log('this.statusEnAttenteDpc', this.statusEnAttenteDpc)

              this.statusAAffecter = response.data.statusAAffecter;
              this.statusATraiter = response.data.statusATraiter;
              this.statusATraiterIds = this.statusATraiter.sous_statuts.map((item) => item.id);
              this.statusATraiterIds.push(this.statusATraiter.id);

              this.statusNeutralise = response.data.statusNeutralise;
              this.statusNeutraliseIds = this.statusNeutralise.sous_statuts.map((item) => item.id);
              this.statusNeutraliseIds.push(this.statusNeutralise.id);

              let statusBonIntegrationNsi = response.data.statusTraite.sous_statuts.reduce((res,status) => {
                return status.libelle_technique === 'traite_bon_integration_nsi' ? status : res;
              },{});
              this.statusBonIntegrationNsi = statusBonIntegrationNsi;

              let statusNeutraliseTemporisation = response.data.statusNeutralise.sous_statuts.reduce((res,status) => {
                return status.libelle_technique === 'neutralise_temporisation' ? status : res;
              },{});
              this.statusNeutraliseTemporisationId = statusNeutraliseTemporisation.id;
              this.statusTraiteIds.push(this.statusNeutraliseTemporisationId)
            })
            .catch((error) => {
              // console.log(error)
              self.handleError(error);
            });

          resolve();
        })
      },
      handleError(error) {
        // console.log(error)
        let text = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI';
        if (!isEmpty(error) && error.response && error.response.status === 403) {
          text = 'Vous n\'avez pas le droit de voir ce dossier';
        } else if (!isEmpty(error) && error.response && error.response.status === 424) {
          text = !isEmpty(error.response.data.infos) ? '<div class="text-left">' + error.response.data.message : error.response.data.message;
          if (!isEmpty(error.response.data.infos)) {
            text = text + '<ul>';
            for (let info of error.response.data.infos) {
              text = text + '<li>' + info + '</li>';
            }
            text = text + '</ul>';
          }
          text = !isEmpty(error.response.data.infos) ? text + '</div>' : text;
        }
        this.$store.commit("IS_LOADING", false);
        this.$swal({
          position: "top",
          type: "error",
          title: "Attention !!",
          html: text,
          showConfirmButton: false,
          timer: 0
        });
        // dans le cas d'une erreur de validation du passage en bon pour intégration module prev', il faut reloader les salaires qui ont peut être était enregistré et ainsi éviter la multiplication des lignes en base (si les lignes de salaire restent avec l'id 0)
        this.$event.emit('reload_salaire');
      },
      validateDataResultat() {
        this.clearErrors()
        // Resultat et motif principal anomalie pour incident à passer au statut traité
        let valid = true;
        if (this.currentTreatment.libelle_technique === 'controle_prestation') {
          if (isEmpty(this.resultatIncident)) {
            valid = false;
            this.errors.resultatIncident = "Veuillez choisir un résultat de contrôle.";
          }
          if ((this.resultatIncident !== this.resultatOKId) && isEmpty(this.motifAnomalie)) {
            valid = false;
            this.errors.motifAnomalie = "Veuillez choisir un motif principal anomalie.";
          }
        }
        if (valid === true) {
          // console.log('this.relatedBloquedDossiers',this.relatedBloquedDossiers)
          if (this.relatedBloquedDossiers.length > 0) {
            this.manageDossierBloque(this.backupTypeForMotifAno);
          } else {
            this.storeData('save');
          }
        }
        return valid
      },
      storeData(typeEnregistrement) {
        // TODO : vérifier pourquoi ça enregistre pas le résultat et le motif d'anomalie pour le traitement "controle_prestation"
        return new Promise(resolve => {
          let self = this
          this.dossier.typeEnregistrement = typeEnregistrement;
          this.dossier.typeDuplication = this.typeDuplication;
          this.dossier.nir = this.nirWithoutKey + this.keyNir;
          this.dossier.nom = this.nom;
          this.dossier.nom_naissance = this.nom_naissance;
          this.dossier.prenom = this.prenom;
          this.dossier.date_naissance = this.date_naissance;
          this.dossier.email = this.email;
          this.dossier.adresse1 = this.adresse1;
          this.dossier.adresse2 = this.adresse2;
          this.dossier.telephone = this.telephone;
          this.dossier.id_pp = this.ppNumber;
          this.dossier.id_pm = this.pmNumber;
          this.dossier.raison_sociale = this.raisonSociale;
          this.dossier.siren = this.siren;
          this.dossier.nic = this.nic;
          this.dossier.oag = this.oag ? this.oag : this.dossier.oag;
          this.dossier.oap = this.oap ? this.oap : this.dossier.oap;
          this.dossier.segment_id = this.selectedSegment;
          this.dossier.nom_declarant_sinistre = this.declarantName;
          this.dossier.mail_declarant_sinistre = this.declarantMail;
          this.dossier.tel_declarant_sinistre = this.declarantTel;
          this.dossier.traitement_id = parseInt(this.$route.query.traitementId);
          this.dossier.type_id = this.selectedType;
          this.dossier.famille_produit_id = this.selectedFamilleProduit;
          //this.dossier.is_exclude_traitement_auto = this.exclusion_traitement_auto;
          // On supprime tout ce qui n'est pas nécessaire pour la mise à jour du dossier pour alléger le post
          this.dossier.mails = ''; 
          this.dossier.mail = '';
          this.dossier.suivis = [];
          this.dossier.gestionnaires = [];
          // this.dossier.status = [];
          // Resultat et motif principal anomalie pour incident à passer au statut traité
          this.dossier.resultat_controle = this.resultatIncident;
          this.dossier.motif_principal = this.resultatIncident === this.resultatOKId ? null : this.motifAnomalie;
          this.dossier.commentaire_controle = this.commentaireControle;
          this.dossier.typeUrgence = this.typeUrgence;
          this.dossier.libelle_regle_cumul = !isEmpty(this.dossier.libelle_regle_cumul) ? this.dossier.libelle_regle_cumul : (this.dossier.regle_cumul_id ? this.dossier.regle_cumul.libelle_technique : 'sans_rc')
          this.dossier.nbIjListe = !isEmpty(this.nbIjListe) ? this.nbIjListe : ''

          // Corriger le bug du flag qui se change à 'Aucun flag' si on ne fait pas une modification de flag mais en cliquant sur Enregistrer
          if (this.dossier.motif_non_pec == undefined) {
            this.dossier.motif_non_pec = !isEmpty(this.dossier.flags) ? this.dossier.flags.reduce((res, item) => item.type !== 'admin' ? item.id : res,'') : '';
          }

          this.$store.commit("IS_LOADING", true);
          this.$axios
            .post("/espaceGestion/dossier/edit/" + this.dossierId, this.dossier)
            .then(async response => {
              if (typeEnregistrement === 'duplicate') {
                // console.log('typeof response.data.duplicatedDossierId',typeof response.data.duplicatedDossierId)
                // if (typeof response.data.duplicatedDossierId === 'integer') {
                //   this.$router.push({
                //     path: `/espace-gestion/dossier/show/${response.data.duplicatedDossierId}`,
                //     query: this.$route.query
                //   });
                // } else {
                  let queries = _.clone(this.$route.query)
                  let seqDossiers = this.getSeqDossiers(queries.seqDossiers);

                  let index = seqDossiers.indexOf(parseInt(this.dossierId))
                  if (index > -1) {
                    seqDossiers.splice(index+1, 0, ...response.data.duplicatedDossierId)
                    // on enlève le dossier courrant pour passer la suite dans next()
                    seqDossiers.shift();
                  } else {
                    seqDossiers.unshift(parseInt(this.dossierId))
                    let newIndex = seqDossiers.indexOf(parseInt(this.dossierId))
                    seqDossiers.splice(newIndex+1, 0, ...response.data.duplicatedDossierId)
                    // on enlève le dossier courrant pour passer la suite dans next()
                    seqDossiers.shift();
                  }

                  queries.seqDossiers = seqDossiers
                  // console.log('queries.seqDossiers',queries.seqDossiers)
                  this.$router.push({
                    path: `/espace-gestion/dossier/show/${this.dossierId}`,
                    query: queries
                  })
                // }
                // window.location.reload();
                this.next();
              } else if (!isEmpty(response.data.relatedDossiersModulePrev)) {
                await this.removeRelatedDossiersModulePrev(response.data.relatedDossiersModulePrev);
                if (typeEnregistrement === 'next') {
                  this.next();
                } else if (typeEnregistrement === 'nextRelated') {
                  this.nextRelated();
                }
              } else {
                if (typeEnregistrement === 'next') {
                  this.next();
                } else if (typeEnregistrement === 'nextRelated') {
                  this.nextRelated();
                }
              }

              this.$store.commit("IS_LOADING", false);
              this.dossier = response.data.dossier;
              this.oag = response.data.dossier.oag;
              this.oap = response.data.dossier.oap;
              this.$store.dispatch('setSelectedDossier', this.dossier);
              this.$event.emit('refreshDossier')
              this.finished = true;
              this.clearErrors();
              this.$event.emit('saveError', this.errors)
              this.setForm(this.dossier, this.beneficiaire, response.data.sirenPreference);
              this.closeModalResultatAno();
              this.$swal({
                position: 'top',
                type: 'success',
                title: '',
                text: 'Modifications bien enregistrées',
                showConfirmButton: false,
                timer: 3000
              });
              if (getUser().profil_active[0].oags.map(oag => oag.code).indexOf(this.oag) === -1 || getUser().profil_active[0].oaps.map(oap => oap.code).indexOf(this.oap) === -1) {
                this.returnBack();
                this.$swal({
                  position: 'top',
                  type: 'warning',
                  title: 'Désolé',
                  text: 'vous ne disposez pas des habilitations nécessaires pour voir cette fiche',
                  showConfirmButton: false,
                  timer: 5000
                });
              }

              // On regarde s'il y a eu changement de type et s'il faut recharger la page dans le nouveau traitement
              if (response.data.hasTypeChanged && typeEnregistrement !== 'next' && typeEnregistrement !== 'nextRelated') {
                let newTreatment = response.data.newTreatment;
                if (newTreatment.id !== parseInt(this.$route.query.traitementId,10) && !this.isQualification) {
                  let queries = _.clone(this.$route.query);
                  queries.traitementId = newTreatment.id;
                  // On garde en mémoire le précédent traitement pour pouvoir l'utiliser si le gestionnaire clique sur dossier suivant ensuite
                  queries.previousTraitementId = this.$route.query.traitementId;
                  this.$router.push({path: this.$route.path, query: queries});
                  location.reload();
                }
              }
            })
            .catch((error) => {
              if (!isEmpty(error.response) && error.response.status === 406) {
                this.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type:"error",
                  title:"Attention !!",
                  html:error.response.data.message,
                  showConfirmButton: false,
                  timer: 9000
                });
                // dans le cas d'une erreur de validation du passage en bon pour intégration module prev', il faut reloader les salaires qui ont peut être était enregistré et ainsi éviter la multiplication des lignes en base (si les lignes de salaire restent avec l'id 0)
                self.$event.emit('reload_salaire')
              } else {
                self.handleError(error);
              }
            })
            .finally(() => resolve());
        })
      },
      removeRelatedDossiersModulePrev(relatedDossiersModulePrev) {
        return new Promise(resolve => {
          let dossiersIds = [];
          let newDossiersIds = [];
          if (typeof this.$route.query.seqDossiers === 'string') {
            dossiersIds.push(parseInt(this.$route.query.seqDossiers,10));
          } else {
            dossiersIds = this.$route.query.seqDossiers.map(function (id) {
              return parseInt(id, 10);
            });
          }

          if (dossiersIds.length > 0) {
            for (let  dossierId of dossiersIds) {
              if (relatedDossiersModulePrev.indexOf(dossierId) === -1) {
                newDossiersIds.push(dossierId)
              }
            }
            let queries = _.clone(this.$route.query);
            queries.seqDossiers = newDossiersIds;
            // On s'occupe de la sequence de dossiers relatifs qu'il faut mettre à 0 car on les a tous passé en IJ
            queries.seqRelatedDossiers = [];
            this.$router.replace({ query: queries });

            resolve();
          } else {
            return resolve();
          }
        })
      },
      isEmptyObject(obj) {
        for (var key in obj) {
          if (obj.hasOwnProperty(key))
            return false;
        }
        return true;
      },
      deneutraliseTempoBPIJ(){
        return new Promise(async resolve => {
          await this.getRequiredFields();
          if (this.validateSave()) {
            let self = this;
            let dataPost = {
              dossierId: this.dossier.id,
              traitementId: this.$route.query.traitementId
            }
            this.$store.commit('IS_LOADING', true);
            this.$axios
              .post("/espaceGestion/dossier/get-back-tempo",dataPost)
              .then(async response => {
                await this.save('save');
                this.$store.commit('IS_LOADING', false);
                this.$event.emit('refreshDossier');
              })
              .catch((error) => {
                self.handleError(error);
              });
          } else {
            this.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Des données obligatories sont manquantes ou des erreurs sont présentes.",
              showConfirmButton: false,
              timer: 3000
            });
          }
           return resolve();
        });
      },
      startReOpen(){
        this.$swal
            .fire({
              title: 'Êtes-vous sûr?',
              text: "Voulez-vous rouvrir cette fiche ?",
              type: 'warning',
              reverseButtons: false,
              showCancelButton: true,
              cancelButtonColor: "#ff1744",
              confirmButtonText: 'Rouvrir',
              cancelButtonText: 'Annuler',
            })
            .then((result) => {
              if(!isEmpty(result.value) && result.value === true ){
                this.$refs['modal-reOpen'].show();
              }
            });
      },
      reOpen(){
        let self = this;
        let currentTreatement = this.allTraitements.filter(traitement => {
            return (parseInt(traitement.id,10) === parseInt(this.$route.query.traitementId,10))
          })

        let dataPost = {};
        //let isAffectedToSystem = false;
        let swalText = {
            title: 'Auto-Affectation',
            text: 'Voulez-vous que le dossier vous soit affecté si ce dernier n\'est pas automatiquement aimanté ?',
            input: 'checkbox',
            inputValue: null,
            inputPlaceholder: 'Me l\'affecter si possible.',
            confirmButtonText: '<i class="fa fa-save"></i>&nbsp;Enregistrer',
            showCancelButton: true,
            reverseButtons: false,
            cancelButtonColor: "#ff1744",
            cancelButtonText: 'Annuler'
          };

       /* if (this.dossier && this.dossier.gestionnaires) {
          for (let gestionnaire of this.dossier.gestionnaires) {
            if (gestionnaire.pivot.traitement_id === parseInt(this.$route.query.traitementId, 10)) {
              if (gestionnaire.id === 999999) {
                isAffectedToSystem = true;
              }
            }
          }
        }*/

        if(this.validateReOpen()){
          this.$swal.fire(swalText)
          .then(async (response) => {

            console.log(response);
            console.log(response.value);
            if(!isEmpty(response.value)){
              let user = getUser();
              /*if(isAffectedToSystem){
                let user = getUser();
                dataPost.autoAffectation = 'autoAffectation';
                dataPost.gestionnaireId = user.id;
              }else{ */
                dataPost.autoAffectation = response.value ? 'autoAffectation' : null;
                dataPost.gestionnaireId =  response.value ? user.id : null;
              //}
              dataPost.dossierId = this.dossierId;
              dataPost.dossierIds = this.dossierId;
              dataPost.commentaireReopen = this.commentaireReopen;
              dataPost.motifRouvetureId = this.motifReopen;

              dataPost.traitementId = this.$route.query.traitementId,
              dataPost.originalGestionnaireId = null;
              dataPost.typeDossierId = [this.dossier.type_id];
              dataPost.for = 'count';


              this.$store.commit("IS_LOADING", true);
              this.$axios
                .post("/espaceGestion/dossier/reOpen",dataPost)
                .then(response => {
                  this.$refs['modal-reOpen'].hide();
                  this.$store.commit("IS_LOADING", false);
                  this.dossier = response.data.dossier;
                  let texte = '';
                  if(response.data.affectationDone){
                    texte = this.getTexteInfosAffectation(response, 'affectation', currentTreatement);
                  }else{
                    texte = 'Réouverture effectuée avec succès';
                  }
                  this.$event.emit('refreshDossier')
                  this.finished = true;
                  this.$event.emit('saveError', this.errors)
                  this.setForm(this.dossier, response.data.sirenPreference);
                  this.$swal({
                    position: 'top',
                    type: 'success',
                    title: '',
                    html: texte,
                    timer: 6000
                });
              })
              .catch((error) => {
                self.handleError(error);
              });
              this.clearErrors();
            }
          })
        }
      },
      getTexteInfosAffectation(response, context, currentTreatement) {
        let texte = context === 'count' ? '<div class="text-left">L\'affectation comprendra ' + response.data.message + ' dossiers' : '<div class="text-left">Affectation de ' + response.data.message + ' dossier(s) réalisée avec succès';
        let typeDossier = 'typeDossier';
        let texteArray = [];
        // console.log('currentTreatement',currentTreatement,currentTreatement.libelle_technique !== 'gestion_dbco')
        // On n'affiche pas d'info sup pour DBCO (sans ça les dossiers affectés sont comptabilisés en tant que prolong)
        if (isEmpty(currentTreatement[0]) || (!isEmpty(currentTreatement[0]) && currentTreatement[0].libelle_technique !== 'gestion_dbco' && currentTreatement[0].libelle_technique !== 'validation_dbco')) {

          if (response.data.nbDossierOuverture > 0) {
            typeDossier = ` ${response.data.nbDossierOuverture} dossier(s) ouverture`;
            texteArray.push(typeDossier)
          }
          if (response.data.nbDossierProlongation > 0) {
            typeDossier = ` ${response.data.nbDossierProlongation} dossier(s) prolongation`;
            texteArray.push(typeDossier)
          }
          if (response.data.nbDossierBpij > 0) {
            typeDossier = ` dont ${response.data.nbDossierBpij} dossier(s) BPIJ`;
            texteArray.push(typeDossier)
          }
          texteArray = texteArray.join(',')
        }
        // console.log('texteArray' + texteArray);
        if (!isEmpty(texteArray)) {
          texte = `${texte} (${texteArray})` + '.<br>';
        } else {
          texte = `${texte}` + '.<br>';
        }
        if (response.data.rejected) {
          let precision = context === 'count' ? 'ne pourront être affectés'  : 'n\'ont pas été affectés';
          texte = texte  + response.data.rejected + ` dossiers ` + precision + ` pour une des raisons suivantes :<br>
            <ul><li>Soit le gestionnaire destinataire n\'a pas le traitement nécessaire pour gérer ces dossiers.</li>
            <li>Soit vous avez choisi de n'affecter que des dossiers sans ouvertures et ceux-ci en contenaient</li></ul></div>`;
        } else {
          texte = texte + '</div>';
        }

        return texte;
      },
      save(type) {
        return new Promise(async resolve => {
          await this.getRequiredFields();
          this.clearErrors();
          if (this.noValidationRequired) {
            // On regarde si on est dans le cas du passage du traitement Fichier prolongation au traitement IJ Gestion
            if (this.statusPassageManuel.id === this.dossier.status_id) {
              this.$swal
                .fire({
                  title: 'Êtes-vous sûr?',
                  text: "Voulez-vous passer ce dossier en traitement manuel ?",
                  type: 'warning',
                  reverseButtons: false,
                  showCancelButton: true,
                  cancelButtonColor: "#ff1744",
                  confirmButtonText: 'Continuer',
                  cancelButtonText: 'Annuler',
                })
                .then(async (result) => {
                  if (result.value) {
                    this.$swal.fire({
                      title: 'Auto-Affectation',
                      text: 'Voulez-vous que le dossier vous soit affecté en traitement Gestion IJ si ce dernier n\'est pas automatiquement aimanté ?',
                      input: 'checkbox',
                      inputValue: null,
                      inputPlaceholder: 'Me l\'affecter si possible.',
                      confirmButtonText: '<i class="fa fa-save"></i>&nbsp;Enregistrer'
                    })
                    .then(async (response) => {
                      // console.log(response)
                      this.dossier.autoAffectation = response.value ? 'autoAffectation' : null;
                      await this.storeData(type);
                      return resolve();
                    })
                  }
                });
            } else if (this.statusBasculeModulePrev.id === this.dossier.status_id) {
              this.$swal
                .fire({
                  title: 'Êtes-vous sûr?',
                  text: "Voulez-vous passer ce dossier en traitement module prév ?",
                  type: 'warning',
                  reverseButtons: false,
                  showCancelButton: true,
                  cancelButtonColor: "#ff1744",
                  confirmButtonText: 'Continuer',
                  cancelButtonText: 'Annuler',
                })
                .then(async (result) => {
                  if (result.value) {
                    await this.storeData(type);
                    return resolve();
                  }
                });
            } else if (this.statusBasculeModulePrevBonIntegration.id === this.dossier.status_id) {
              this.$swal
                .fire({
                  title: 'Êtes-vous sûr?',
                  text: "Voulez-vous passer ce dossier en traitement module prév bon pour intégration ?",
                  type: 'warning',
                  reverseButtons: false,
                  showCancelButton: true,
                  cancelButtonColor: "#ff1744",
                  confirmButtonText: 'Continuer',
                  cancelButtonText: 'Annuler',
                })
                .then(async (result) => {
                  if (result.value) {
                    await this.storeData(type);
                    return resolve();
                  }
                });
            } else if (this.statusBonIntegrationNsi.id === this.dossier.status_id) {
                if (this.isIjModulePrevoyance && this.dossier.libelle_regle_cumul !== "sans_rc") {
                  this.$swal
                    .fire({
                      position: "top",
                      type: "warning",
                      title: "Attention !!",
                      text: "Ce dossier est détecté avec une RC positionnée, sans retirer ce critère, il n'est pas possible de valider ce dossier en traitement Module Prév', merci de le traiter manuellement",
                      showConfirmButton: true
                    })
                    .then(async (result) => {
                      return resolve();
                    });
                } else {
                  await this.storeData(type);
                  return resolve();
                }
            } else {
              await this.storeData(type);
              return resolve();
            }
          }
          else {
            if(isEmpty(this.selectedType)) {
              this.errors.selectedType = 'Veuillez choisir le type du dossier';
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Le type du dossier est obligatoire.",
                showConfirmButton: false,
                timer: 2000
              });
              this.$event.emit('saveError', this.errors);
              return resolve();
            }
            if (!isEmpty(this.dossier.montant_ij_ss)) {
              let montantIJSS = this.dossier.montant_ij_ss.replace(',','.');
              if (parseFloat(montantIJSS) > 999.99) {
                this.errors.montantIJSS = 'Le montant IJSS ne peut dépasser 999,99';
                this.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Il y a une erreur sur le Montant IJSS.",
                  showConfirmButton: false,
                  timer: 2000
                });
                this.$event.emit('saveError', this.errors);
                return resolve();
              }
            }
            if (this.validateStatusIncidentSave()) {
              if (this.validateSave()) {
                if(this.verifierConditionAffichageMsgNsi()) {
                  this.$swal
                    .fire({
                      title: 'Êtes-vous sûr?',
                      text: "Êtes-vous certain d’avoir traité le dossier dans NSI avant de clôturer celui-ci au motif « TRAITE » ?",
                      type: 'warning',
                      reverseButtons: false,
                      showCancelButton: true,
                      cancelButtonColor: "#ff1744",
                      confirmButtonText: 'Enregistrer',
                      cancelButtonText: 'Annuler',
                    })
                    .then(async (result) => {
                      if (result.value === true) {
                        if (checkNIR(this.nirWithoutKey + this.keyNir) && this.checkCompletudeInvalPfe()) {
                            await this.storeData(type);
                            return resolve();
                        } else {
                          let texte = '';
                          if(!checkNIR(this.nirWithoutKey + this.keyNir)){
                            texte = "Voulez-vous enregistrer même si le NIR est invalide ou absent ?";
                          }
                          if(!this.checkCompletudeInvalPfe()){
                            texte = texte + '<br> ' + "Voulez-vous enregistrer même si la catégorie ou la date de mise en invalidité est absent ?";
                          }
                          await this.$swal
                            .fire({
                              title: 'Êtes-vous sûr?',
                              html: texte,
                              type: 'warning',
                              reverseButtons: false,
                              showCancelButton: true,
                              cancelButtonColor: "#ff1744",
                              confirmButtonText: 'Enregistrer',
                              cancelButtonText: 'Annuler',
                            })
                            .then(async (result) => {
                              if (result.value === true) {
                                await this.storeData(type);
                                return resolve();
                              }
                            });
                        }
                      }
                    });

                } else {
                  // TODO : afficher pop up avec resulat et motif anomalie
                  let choosenStatus = this.currentTreatment.status.reduce((res,status) => status.id === parseInt(this.dossier.status_id,10) ? status : res, null);
                  if (checkNIR(this.nirWithoutKey + this.keyNir) && this.checkCompletudeInvalPfe()) {
                    if (this.currentTreatment.libelle_technique === 'ij_expertise_presta_niv2' || this.currentTreatment.libelle_technique === 'controle_prestation') {
                      if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && choosenStatus.libelle_technique !== 'traite_doublon_deja_controle') {
                        this.clearErrors();
                        this.backupTypeForMotifAno = type;
                        this.$refs['modal-resultat-motifAno'].show()
                      } else {
                        await this.storeData(type);
                        return resolve();
                      }
                    } else {
                      await this.storeData(type);
                      return resolve();
                    }
                  } else {
                    let texte = '';
                    if(!checkNIR(this.nirWithoutKey + this.keyNir)){
                      texte = "Voulez-vous enregistrer même si le NIR est invalide ou absent ?";
                    }
                    if(!this.checkCompletudeInvalPfe()){
                      texte = texte + '<br> ' + "Voulez-vous enregistrer même si la catégorie ou la date de mise en invalidité est absent ?";
                    }
                    await this.$swal
                      .fire({
                        title: 'Êtes-vous sûr?',
                        html: texte,
                        type: 'warning',
                        reverseButtons: false,
                        showCancelButton: true,
                        cancelButtonColor: "#ff1744",
                        confirmButtonText: 'Enregistrer',
                        cancelButtonText: 'Annuler',
                      })
                      .then(async (result) => {
                        if (result.value === true) {
                          if (this.currentTreatment.libelle_technique === 'ij_expertise_presta_niv2' || this.currentTreatment.libelle_technique === 'controle_prestation') {
                            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && choosenStatus.libelle_technique !== 'traite_doublon_deja_controle') {
                              this.clearErrors();
                              this.backupTypeForMotifAno = type;
                              this.$refs['modal-resultat-motifAno'].show()
                            } else {
                              await this.storeData(type);
                              return resolve();
                            }
                          } else {
                            await this.storeData(type);
                            return resolve();
                          }
                        }
                      });
                  }

                  // console.log('dans le else')
                  // if(this.continueCheckNir()) {
                  //   console.log('dans le continuechecknir')
                  //   await this.storeData(type);
                  //   resolve();
                  // } else {
                  //   console.log('dans le else continuechecknir')
                  // }
                }
              } else {
                this.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Des données obligatories sont manquantes ou erronées.",
                  showConfirmButton: false,
                  timer: 2000
                });
                this.$event.emit('saveError', this.errors);
                return resolve();
              }
            } else {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Vous ne pouvez pas clore le dossier car il reste des incidents non résolus.",
                showConfirmButton: false,
                timer: 0
              });
              return resolve();
            }
          }
        })

      },
      async initiateSave(type) {
        // On est obligé de dupliquer les tests de validité d'enregistrement à cause des promise qui doivent se résoudre et du fonctionnement des dossiers bloqués qui passe par une nouvelle modal
        // On passe maintenant par cette étape lors de l'enregistrement, pour laisser la fonction save() inchangé car d'autres components l'utilisent
        await this.getRequiredFields();
        this.clearErrors();
        if (this.noValidationRequired) {
          // On regarde si on est dans le cas du passage du traitement Fichier prolongation au traitement IJ Gestion
          if (this.statusPassageManuel.id === this.dossier.status_id) {
            this.$swal
              .fire({
                title: 'Êtes-vous sûr?',
                text: "Voulez-vous passer ce dossier en traitement manuel ?",
                type: 'warning',
                reverseButtons: false,
                showCancelButton: true,
                cancelButtonColor: "#ff1744",
                confirmButtonText: 'Continuer',
                cancelButtonText: 'Annuler',
              })
              .then(async (result) => {
                if (result.value) {
                  this.$swal.fire({
                    title: 'Auto-Affectation',
                    text: 'Voulez-vous que le dossier vous soit affecté en traitement Gestion IJ si ce dernier n\'est pas automatiquement aimanté ?',
                    input: 'checkbox',
                    inputValue: null,
                    inputPlaceholder: 'Me l\'affecter si possible.',
                    confirmButtonText: '<i class="fa fa-save"></i>&nbsp;Enregistrer'
                  })
                  .then(async (response) => {
                    // console.log(response)
                    this.dossier.autoAffectation = response.value ? 'autoAffectation' : null;
                    this.storeData(type);
                  })
                }
              });
          } else {
            let choosenStatus = this.currentTreatment.status.reduce((res,status) => status.id === parseInt(this.dossier.status_id,10) ? status : res, null);
            if (this.hasRelatedBlocked && (choosenStatus.libelle_technique === 'traite_passage_module_prevoyance' || choosenStatus.libelle_technique === 'traite_passage_module_prevoyance_bon_integration')) {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Vous ne pouvez pas passer ce dossier en module prev' car il est relié à des dossiers en paiement bloqué.",
                showConfirmButton: false,
                timer: 0
              });
            } else {
              this.storeData(type);
            }
          }
        } else {
          if (this.relatedBloquedDossiers.length > 0) {
            // Si le statut est un des statuts de passage en module prev', il faut regarder s'il y a des dossiers en paiement bloqué
            let choosenStatus = this.currentTreatment.status.reduce((res,status) => status.id === parseInt(this.dossier.status_id,10) ? status : res, null);
            if (this.hasRelatedBlocked && (choosenStatus.libelle_technique === 'traite_passage_module_prevoyance' || choosenStatus.libelle_technique === 'traite_passage_module_prevoyance_bon_integration')) {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Vous ne pouvez pas passer ce dossier en module prev' car il est relié à des dossiers en paiement bloqué.",
                showConfirmButton: false,
                timer: 0
              });
            } else if (this.validateStatusIncidentSave()) {
              if (this.validateSave()) {
                if(this.verifierConditionAffichageMsgNsi()) {
                  this.$swal
                    .fire({
                      title: 'Êtes-vous sûr?',
                      text: "Êtes-vous certain d’avoir traité le dossier dans NSI avant de clôturer celui-ci au motif « TRAITE » ?",
                      type: 'warning',
                      reverseButtons: false,
                      showCancelButton: true,
                      cancelButtonColor: "#ff1744",
                      confirmButtonText: 'Enregistrer',
                      cancelButtonText: 'Annuler',
                    })
                    .then(async (result) => {
                      if (result.value === true) {
                        if (checkNIR(this.nirWithoutKey + this.keyNir) && this.checkCompletudeInvalPfe()) {
                          this.manageDossierBloque(type);
                        } else {
                          let texte = '';
                          if(!checkNIR(this.nirWithoutKey + this.keyNir)){
                            texte = "Voulez-vous enregistrer même si le NIR est invalide ou absent ?";
                          }
                          if(!this.checkCompletudeInvalPfe()){
                            texte = texte + '<br> ' + "Voulez-vous enregistrer même si la catégorie ou la date de mise en invalidité est absent ?";
                          }
                          this.$swal
                            .fire({
                              title: 'Êtes-vous sûr?',
                              html: texte,
                              type: 'warning',
                              reverseButtons: false,
                              showCancelButton: true,
                              cancelButtonColor: "#ff1744",
                              confirmButtonText: 'Enregistrer',
                              cancelButtonText: 'Annuler',
                            })
                            .then(async (result) => {
                              if (result.value === true) {
                                this.manageDossierBloque(type);
                              }
                            });
                        }
                      }
                    });
                } else {
                    // TODO : afficher pop up avec resulat et motif anomalie
                    let choosenStatus = this.currentTreatment.status.reduce((res,status) => status.id === parseInt(this.dossier.status_id,10) ? status : res, null);
                    if (checkNIR(this.nirWithoutKey + this.keyNir) && this.checkCompletudeInvalPfe()) {
                      if (this.currentTreatment.libelle_technique === 'ij_expertise_presta_niv2' || this.currentTreatment.libelle_technique === 'controle_prestation') {
                        if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && choosenStatus.libelle_technique !== 'traite_doublon_deja_controle') {
                          this.clearErrors();
                          this.backupTypeForMotifAno = type;
                          this.$refs['modal-resultat-motifAno'].show()
                        } else {
                          this.manageDossierBloque(type);
                        }
                      } else {
                        this.manageDossierBloque(type);
                      }
                    } else {
                      let texte = '';
                        if(!checkNIR(this.nirWithoutKey + this.keyNir)){
                          texte = "Voulez-vous enregistrer même si le NIR est invalide ou absent ?";
                        }
                        if(!this.checkCompletudeInvalPfe()){
                          texte = texte + '<br> ' + "Voulez-vous enregistrer même si la catégorie ou la date de mise en invalidité est absent ?";
                        }
                      this.$swal
                        .fire({
                          title: 'Êtes-vous sûr?',
                          html: texte,
                          type: 'warning',
                          reverseButtons: false,
                          showCancelButton: true,
                          cancelButtonColor: "#ff1744",
                          confirmButtonText: 'Enregistrer',
                          cancelButtonText: 'Annuler',
                        })
                        .then(async (result) => {
                          if (result.value === true) {
                            this.manageDossierBloque(type);
                          }
                        });
                    }
                  }
              } else {
                this.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Des données obligatories sont manquantes ou erronées.",
                  showConfirmButton: false,
                  timer: 2000
                });
                this.$event.emit('saveError', this.errors);
              }
            } else {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Vous ne pouvez pas clore le dossier car il reste des incidents non résolus.",
                showConfirmButton: false,
                timer: 0
              });
            }
          } else {
            if (this.validateStatusIncidentSave()) {
              if (this.validateSave()) {
                if(this.verifierConditionAffichageMsgNsi()) {
                  this.$swal
                    .fire({
                      title: 'Êtes-vous sûr?',
                      text: "Êtes-vous certain d’avoir traité le dossier dans NSI avant de clôturer celui-ci au motif « TRAITE » ?",
                      type: 'warning',
                      reverseButtons: false,
                      showCancelButton: true,
                      cancelButtonColor: "#ff1744",
                      confirmButtonText: 'Enregistrer',
                      cancelButtonText: 'Annuler',
                    })
                    .then(async (result) => {
                      if (result.value === true) {
                        if (checkNIR(this.nirWithoutKey + this.keyNir) && this.checkCompletudeInvalPfe()) {
                          this.storeData(type);
                        } else {
                          let texte = '';
                          if(!checkNIR(this.nirWithoutKey + this.keyNir)){
                            texte = "Voulez-vous enregistrer même si le NIR est invalide ou absent ?";
                          }
                          if(!this.checkCompletudeInvalPfe()){
                            texte = texte + '<br> ' + "Voulez-vous enregistrer même si la catégorie ou la date de mise en invalidité est absent ?";
                          }
                          this.$swal
                            .fire({
                              title: 'Êtes-vous sûr?',
                              html: texte,
                              type: 'warning',
                              reverseButtons: false,
                              showCancelButton: true,
                              cancelButtonColor: "#ff1744",
                              confirmButtonText: 'Enregistrer',
                              cancelButtonText: 'Annuler',
                            })
                            .then(async (result) => {
                              if (result.value === true) {
                                this.storeData(type);
                              }
                            });
                        }
                      }
                    });
                } else {
                  // TODO : afficher pop up avec resulat et motif anomalie
                  let choosenStatus = this.currentTreatment.status.reduce((res,status) => status.id === parseInt(this.dossier.status_id,10) ? status : res, null);
                  if (checkNIR(this.nirWithoutKey + this.keyNir) && this.checkCompletudeInvalPfe()) {
                    if (this.currentTreatment.libelle_technique === 'ij_expertise_presta_niv2' || this.currentTreatment.libelle_technique === 'controle_prestation') {
                      if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && choosenStatus.libelle_technique !== 'traite_doublon_deja_controle') {
                        this.clearErrors();
                        this.backupTypeForMotifAno = type;
                        this.$refs['modal-resultat-motifAno'].show()
                      } else {
                        this.storeData(type);
                      }
                    } else {
                      this.storeData(type);
                    }
                  } else {
                      let texte = '';
                      if(!checkNIR(this.nirWithoutKey + this.keyNir)){
                        texte = "Voulez-vous enregistrer même si le NIR est invalide ou absent ?";
                      }
                      if(!this.checkCompletudeInvalPfe()){
                        texte = texte + '<br> ' + "Voulez-vous enregistrer même si la catégorie ou la date de mise en invalidité est absent ?";
                      }
                    this.$swal
                      .fire({
                        title: 'Êtes-vous sûr?',
                        html: texte,
                        type: 'warning',
                        reverseButtons: false,
                        showCancelButton: true,
                        cancelButtonColor: "#ff1744",
                        confirmButtonText: 'Enregistrer',
                        cancelButtonText: 'Annuler',
                      })
                      .then(async (result) => {
                        if (result.value === true) {
                          this.storeData(type);
                        }
                      });
                  }
                }
              } else {
                this.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Des données obligatories sont manquantes ou erronées.",
                  showConfirmButton: false,
                  timer: 2000
                });
                this.$event.emit('saveError', this.errors);
              }
            } else {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Vous ne pouvez pas clore le dossier car il reste des incidents non résolus.",
                showConfirmButton: false,
                timer: 0
              });
            }
          }
        }
      },
      manageDossierBloque(type) {
        this.saveType = type;
        // On regarde si on n'est pas dans le cas d'un passage au statut "bloqué paiement", auquel cas on ne s'occupe pas des dossiers bloqués
        let statusBloque = this.allStatus.find(status => status.libelle_technique === 'traite_paiement_bloque');
        let statusTraiteNsi = this.allStatus.find(status => status.libelle_technique === 'traite_finalise_nsi');
        let statusNeutraliseTemporisationBpij = this.allStatus.find(status => status.libelle_technique === 'neutralise_temporisation');

        if (this.dossier.status_id !== statusBloque.id) {
          // On regarde si on n'est pas dans le cas d'un traitement expert en mode "Traité dans NSI" auquel cas il faut prendre les statuts du traitement principal et non pas ce de ce traitement qui est un traitement secondaire.
          if (this.dossier.status_id === statusTraiteNsi.id) {
            // Le statut choisi pour ce dossier pour le traitement principal se trouve dans this.dossier.main_treatment_status_id
            this.statusBloquedDossierOptions = [];
            let mainTreatmentStatus = [];
            if (this.dossierMainTreatment) {
              mainTreatmentStatus = _.filter(this.dossierMainTreatment.status, (status) => this.statusTraiteIds.indexOf(status.id) > -1 && status.libelle_technique !== 'traite_fusionne' && status.libelle_technique !== 'traite_dpc_sans_reponse' && status.libelle_technique !== 'traite_integration_reussi_nsi' && status.libelle_technique !== 'traite_integration_refuse_nsi');
            }

            for (let status of mainTreatmentStatus) {
              this.statusBloquedDossierOptions.push({
                value: status.id,
                text: status.parent ? status.parent.libelle_bo + ' - ' + status.libelle_bo : status.libelle_bo,
              });
            }
            // On pré-rempli les select avec le même statut que celui choisi pour ce dossier pour le traitement principal
            for (let dossier of this.relatedBloquedDossiers) {
              this.statusBloquedDossier[dossier.id] = this.dossier.main_treatment_status_id;
            }
          } else {
            let attachedStatus = _.filter(this.currentTreatment.status, (status) => this.statusTraiteIds.indexOf(status.id) > -1 && status.libelle_technique !== 'traite_fusionne' && status.libelle_technique !== 'traite_integration_reussi_nsi' && status.libelle_technique !== 'traite_integration_refuse_nsi' && status.libelle_technique !== 'traite_bascule_module_prev');
            // On rempli les options du select
            for (let status of attachedStatus) {
              this.statusBloquedDossierOptions.push({
                value: status.id,
                text: status.parent ? status.parent.libelle_bo + ' - ' + status.libelle_bo : status.libelle_bo,
              });
            }

            this.statusBloquedDossierOptions.push({
              value: statusNeutraliseTemporisationBpij.id,
              text: statusNeutraliseTemporisationBpij.parent ? statusNeutraliseTemporisationBpij.parent.libelle_bo + ' - ' + statusNeutraliseTemporisationBpij.libelle_bo : statusNeutraliseTemporisationBpij.libelle_bo,
            });

            // On pré-rempli les select avec le même statut que celui choisi pour ce dossier
            for (let dossier of this.relatedBloquedDossiers) {
              this.statusBloquedDossier[dossier.id] = this.dossier.status_id;
            }
          }

          this.$refs['modal-dossiers-bloques'].show();
        } else {
          this.storeData(type);
        }
      },
      saveBlockedDossier(type) {
        let self = this;
        if (type === 'ignore') {
          this.storeData(this.saveType);
          this.$refs['modal-dossiers-bloques'].hide();
        } else {
          if (this.validateSaveBlockedDossier()) {
            let traitementId = this.$route.query.traitementId;
            // On regarde si on est dans le cas d'un traitement secondaire qui clos dans NSI, auquel cas il faut envoyer le maintraitement plutôt que le route.query
            let choosenStatus = this.currentTreatment.status.reduce((res,status) => status.id === parseInt(this.dossier.status_id,10) ? status : res, null);
            if (choosenStatus.libelle_technique === 'traite_finalise_nsi') {
              traitementId = this.dossierMainTreatment.id;
            }
            // On commence par enregistrer les statuts pour les dossiers relatifs bloqués
            let dataPost = {
              statusDossier: this.statusBloquedDossier,
              selectedDossier: this.selectedBloquedDossier,
              traitementId: traitementId,
            };
            this.$axios
            .post("/espaceGestion/dossier/related-blocked/save", dataPost)
            .then(response => {
              // On enregistre le dossier actuel
              this.storeData(this.saveType);
              this.$refs['modal-dossiers-bloques'].hide();
              this.$event.emit('refreshHistoSinistre');
              // Il faut retirer de la séquence de dossier ceux que l'on vient de fermer
              let dossiersIds = this.getSeqDossiers(this.$route.query.seqDossiers);
              let seqRelatedDossiers = this.getSeqDossiers(this.$route.query.seqRelatedDossiers);
              if (dossiersIds.length > 0 || seqRelatedDossiers.length > 0) {
                for (let dossierId of this.selectedBloquedDossier) {
                  if (seqRelatedDossiers.length > 0) {
                    seqRelatedDossiers.splice(seqRelatedDossiers.indexOf(dossierId),1);
                  }
                  if (dossiersIds.length > 0) {
                    dossiersIds.splice(dossiersIds.indexOf(dossierId),1);
                  }
                }
              }

              this.$route.query.seqDossiers = dossiersIds;
              this.$route.query.seqRelatedDossiers = seqRelatedDossiers;
            })
            .catch((error) => {
              console.log(error)
              if (error.response && error.response.status === 424) {
                let messages = error.response.data.message.join('<br>');
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  html: messages,
                  // text:error.response.data.message,
                  showConfirmButton: false,
                  timer: 5000
                });
              } else {
                self.handleError(error);
              }
            })
          }
        }
      },
      validateSaveBlockedDossier() {
        this.clearErrors();
        let valid = true;

        if (isEmpty(this.selectedBloquedDossier)) {
          valid = false;
          this.errors.selectedBloquedDossier = 'Vous devez sélectionner les dossiers dont vous voulez changer le statut';
        }
        return valid;
      },
      getStatusDossierBloque(dossier) {
        let satatusDossier =  dossier.status.find( status => status.pivot.traitement_id === parseInt(this.$route.query.traitementId,10));
        return !isEmpty(satatusDossier) ? satatusDossier.libelle_bo : '';
      },
      duplicationModal() {
        this.$refs['modal-duplication'].show();
      },
      duplicateIjListe(nbIjListe) {
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous créer " + nbIjListe + " dossiers à partir de ce dossier ?",
            type: 'warning',
            reverseButtons: false,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: 'Enregistrer',
            cancelButtonText: 'Annuler',
          })
          .then((result) => {
            if (result.value) {
              this.storeData('duplicate')
            }
          });
      },
      closeModal(modalRef) {
        this.$refs[modalRef].hide();
      },
      closeModalReOpen(){
        this.commentaireReopen = '';
        this.motifReopen = '';
        this.clearErrors();
        this.$refs['modal-reOpen'].hide();
      },
      closeModalResultatAno() {
        this.resultatIncident = '';
        this.motifAnomalie = '';
        this.commentaireControle = '';
        this.clearErrors();
        this.$refs['modal-resultat-motifAno'].hide();
      },
      validateStatusIncidentSave() {
        let valid = true
        if (this.isQualification || this.isIjGestionPrestation || this.isIjModulePrevoyance || this.dossier.canal.libelle_technique === 'bpij') {
          if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1) {
            let incidentNonClos = false
            for (let incident of this.dossier.incidents) {
              if (this.statusTraiteIds.indexOf(incident.status_id) === -1 && parseInt(incident.status_id) !== 0 && parseInt(incident.traitement_ps_id,10) !== parseInt(this.$route.query.traitementId,10)) {
                incidentNonClos = true;
              }
            }
            valid = !incidentNonClos;
          }
        }

        return valid;
      },
      validateReOpen() {
        let valid = true;

        // if (isEmpty(this.commentaireReopen)) {
        //   valid = false;
        //   this.errors.commentaireReopen = 'Le commenaire est obligatoire';
        // }

        if (isEmpty(this.motifReopen)) {
          valid = false;
          this.errors.motifReopen = 'Le motif de rouverture est obligatoire';
        }

        return valid;
      },
      validateSave() {
        let valid = true;
        for (let field of this.requiredFields) {
          switch (field) {
            case 'selectedType':
              if (isEmpty(this.selectedType)) {
                valid = false;
                this.errors.selectedType = 'Le type de dossier est obligatoire';
              }
              break;
            case 'selectedFamilleProduit':
              if (isEmpty(this.selectedFamilleProduit)) {
                valid = false;
                this.errors.selectedFamilleProduit = 'Le produit est obligatoire';
              }
              break;
            case 'nirWithoutKey':
              if (this.verifyCheckBoxes && this.nirIndisponible) {
                this.errors.nirWithoutKey = '';
              } else if (isEmpty(this.nirWithoutKey)) {
                valid = false;
                this.errors.nirWithoutKey = 'Le NIR est obligatoire';
              }
              break;
            case 'nom':
              if (this.isConformiteDBCO || this.isValidationConformiteDBCO) {
                if (isEmpty(this.nom_naissance) && isEmpty(this.nom)) {
                  valid = false;
                  this.errors.nom = 'Vous devez saisir le nom d\'usage ou le nom de naissance';
                }
              } else {
                if (isEmpty(this.nom)) {
                  valid = false;
                  this.errors.nom = 'Le nom est obligatoire';
                }
              }
              break;
            case 'prenom':
              if (isEmpty(this.prenom)) {
                valid = false;
                this.errors.prenom = 'Le prenom est obligatoire';
              }
              break;
            case 'siren':
              if (this.verifyCheckBoxes && this.sirenIndisponible) {
                this.errors.siren = '';
              } else if (isEmpty(this.siren) && !((this.isConformiteDBCO || this.isValidationConformiteDBCO) && this.sirenIndisponible)) {
                // Cas particulier des DBCO où seule la coche SIREN est acceptée
                valid = false;
                this.errors.siren = 'Le SIREN est obligatoire';
              }
              break;
            case 'nic':
              if (this.verifyCheckBoxes && this.validateNic) {
                this.errors.nic = '';
              } else if (isEmpty(this.nic) && this.isIjModulePrevoyance) {
                valid = false;
                this.errors.nic = 'Le NIC est obligatoire';
              }
              break;
            case 'date_reception':
              if (isEmpty(this.dossier.date_reception)) {
                valid = false;
                this.errors.dateReception = 'La date de réception est obligatoire';
              }
              break;
            case 'date_debut_periode':
              if (this.verifyCheckBoxes && this.dateDebutSinistreIndisponible) {
                this.errors.date_du = '';
              } else if (isEmpty(this.dossier.date_debut_periode) && !this.isQualification) {
                valid = false;
                this.errors.date_du = 'La date de début de période est obligatoire';
              } else if (!isEmpty(this.dossier.date_fin_periode)) {
                let dateDebut = new Date(this.dossier.date_debut_periode).getTime();
                let dateFin = new Date(this.dossier.date_fin_periode).getTime();
                let dateReception = new Date(this.dossier.date_reception.split(' ')[0]).getTime();
                if (this.isIjModulePrevoyance || (this.isIjGestionPrestation && (this.statusBasculeModulePrevBonIntegration.id === this.dossier.status_id))) {
                  let selectedStatus = this.allStatus.reduce((res, status) => parseInt(status.id,10) === parseInt(this.dossier.status_id) ? status : res,{});
                  if (selectedStatus.libelle_technique === 'traite_bon_integration_nsi') {
                    let nbJour = (dateFin - dateDebut) / (1000 * 3600 * 24);
                    if (nbJour > 90) {
                      valid = false;
                      this.errors.date_du = 'Période maximum autorisée pour ce traitement : 90 jours. Passez en saisie manuelle.';
                    }
                  }
                  if (dateFin > dateReception) {
                    valid = false;
                    this.errors.date_au = 'La date de fin de période ne peut être supérieure à la date de réception de la demande';
                  }
                }
                if (dateDebut && dateDebut > dateFin) {
                  valid = false;
                  this.errors.date_du = 'Incompatibilité avec la date de fin de période';
                  this.errors.date_au = 'La date de fin de période ne peut être antérieur à la date de début de période';
                }

                let dateReceptionDate = new Date(this.dossier.date_reception);
                let minDateDebutPsi = dateReceptionDate.setFullYear(dateReceptionDate.getFullYear() - 5);
                if(dateDebut < minDateDebutPsi){
                  valid = false;
                  this.errors.date_du = 'Saisissez une date à maximum 5 ans avant la date de réception ';
                }
              }
              break;
            case 'date_fin_periode':
              if (isEmpty(this.dossier.date_fin_periode)) {
                valid = false;
                this.errors.date_au = 'La date de fin de période est obligatoire';
              }
              break;
            case 'montant_ij_ss':
              if (isEmpty(this.dossier.montant_ij_ss) || isEmpty(this.dossier.montant_ij_ss.trim())) {
                valid = false;
                this.errors.montantIJSS = 'Le montant IJSS est obligatoire';
              }
              break;
            case 'montant_ij_ss_net':
              if (!isEmpty(this.dossier.montant_ij_ss_net) && isNaN(this.dossier.montant_ij_ss_net)) {
                valid = false;
                this.errors.montantIJSSNet = "Le montant IJSS net doit être un entier ou un décimal";
              }
              break;
            case 'dateDeces':
              if (isEmpty(this.dossier.date_deces)) {
                valid = false;
                this.errors.dateDeces = 'La date de décès est obligatoire';
              }
              break;
            case 'date_information_deces':
              if (isEmpty(this.dossier.date_information_deces)) {
                valid = false;
                this.errors.dateDeces = 'La date d\'information du décès est obligatoire';
              }
              break;
            case 'typeDeces':
              if (isEmpty(this.dossier.type_deces)) {
                valid = false;
                this.errors.typeDeces = 'Le type de décès est obligatoire';
              }
              break;
            case 'capitalDeces':
              if (this.dossier.capital_verse !== true && this.dossier.capital_superieur !== true) {
                valid = false;
                this.errors.capitalDeces = 'Le capital de décès est obligatoire';
              }
              break;
            case 'typeRente':
              if (this.dossier.rente_conjoint !== true && this.dossier.rente_education !== true && this.dossier.rente_ocirp !== true) {
                valid = false;
                this.errors.typeRente = 'Le type de rente est obligatoire';
              }
              break;
            case 'beneficiaireTraite':
              let findBeneficiaireNotTraite = false;
              for (let beneficiaire of this.dossier.deces_beneficiaire) {
                if (isEmpty(beneficiaire.status) || beneficiaire.status.libelle_technique.substring(0,25) !== 'beneficiaire_deces_traite') {
                  findBeneficiaireNotTraite = true;
                }
              }
              if (findBeneficiaireNotTraite) {
                valid = false;
                this.errors.clotureDeces = 'Vous ne pouvez clore ce dossier car le statut d\'au moins un bénéficiaire n\'est pas "Traité"'
              }
              break;
            case 'raisonSociale':
              if (isEmpty(this.raisonSociale)) {
                valid = false;
                this.errors.raisonSociale = 'La raison sociale est obligatoire';
              }
              break;
            case 'categorieInval':
              if (isEmpty(this.dossier.categorie_inval)) {
                valid = false;
                this.errors.categorieInval = 'La catégorie est obligatoire';
              }
              break;
            case 'dateEffet':
              if (isEmpty(this.dossier.date_effet)) {
                valid = false;
                this.errors.dateEffet = "La date d'effet est obligatoire";
              }
              break;
            case 'taux':
              if (isEmpty(this.dossier.taux_incapacite)) {
                valid = false;
                this.errors.taux = 'Le taux est obligatoire';
              }
              break;
            case 'main_treatment_status_id':
              if (isEmpty(this.dossier.main_treatment_status_id)) {
                valid = false;
                this.errors.mainTreatmentStatus = 'Vous devez choisir un statut pour le traitement principal';
              }
              break;
            case 'nom_naissance':
              if (this.isConformiteDBCO || this.isValidationConformiteDBCO) {
                if (isEmpty(this.nom_naissance) && isEmpty(this.nom)) {
                  valid = false;
                  this.errors.nom_naissance = 'Vous devez saisir le nom de naissance ou le nom d\'usage';
                }
              } else {
                if (isEmpty(this.nom_naissance)) {
                  valid = false;
                  this.errors.nom_naissance = 'Vous devez saisir le nom de naissance';
                }
              }
              break;
            case 'adresse1':
              if (isEmpty(this.dossier.adresse1)) {
                valid = false;
                this.errors.adresse1 = 'Vous devez entrer l\'adresse';
              }
              break;
            case 'adresse2':
              if (isEmpty(this.dossier.adresse2)) {
                valid = false;
                this.errors.adresse2 = 'Vous devez saisir le code postal et la ville';
              }
              break;
            case 'email':
              if (isEmpty(this.email)) {
                valid = false;
                this.errors.email = 'Vous devez saisir l\'adresse mail.';
              }
              break;
            case 'dateSignature':
              let $dateSignature = !isEmpty(this.dossier.dateSignature) ? this.dossier.dateSignature : this.dossier.date_signature;
              if (!isEmpty($dateSignature)) {
                let dateSignature = new Date($dateSignature.split(' ')[0]).getTime();
                let dateReception = new Date(this.dossier.date_reception.split(' ')[0]).getTime();
                let dateReceptionCourrier = !isEmpty(this.dossier.dateReceptionCourrier) ? new Date(this.dossier.dateReceptionCourrier).getTime() : (!isEmpty(this.dossier.date_reception_courrier) ? new Date(this.dossier.date_reception_courrier).getTime() : null);
                if (dateSignature > dateReception) {
                  valid = false;
                  this.errors.dateSignature = 'La date de signature ne peut pas être supérieure à la date de réception';
                }
                if (!isEmpty(dateReceptionCourrier) && dateSignature > dateReceptionCourrier) {
                  this.errors.dateSignature = 'La date de signature ne peut pas être supérieure à la date de réception du courrier';
                }
                // console.log('cas $dateSignature',dateReceptionCourrier, dateSignature, dateSignature > dateReceptionCourrier)
              }
              break;
            case 'dateReceptionCourrier':
              if (isEmpty(this.dossier.dateReceptionCourrier) && isEmpty(this.dossier.date_reception_courrier)) {
                valid = false;
                this.errors.dateReceptionCourrier = 'Vous devez saisir la date de réception du courrier';
              } else {
                if (!isEmpty(this.dossier.dateReceptionCourrier)) {
                  let dateReceptionCourrier = new Date(this.dossier.dateReceptionCourrier.split(' ')[0]).getTime();
                  let dateReception = new Date(this.dossier.date_reception.split(' ')[0]).getTime();
                  // console.log(dateReceptionCourrier, dateReception, this.dossier.dateReceptionCourrier, this.dossier.date_reception)
                  if (dateReceptionCourrier > dateReception) {
                    valid = false;
                    this.errors.dateReceptionCourrier = 'La date de réception réelle ne peut pas être supérieure à la date de réception dans Atlas';
                  }
                } else if (!isEmpty(this.dossier.date_reception_courrier)) {
                  let dateReceptionCourrier = new Date(this.dossier.date_reception_courrier.split(' ')[0]).getTime();
                  let dateReception = new Date(this.dossier.date_reception.split(' ')[0]).getTime();
                  // console.log(dateReceptionCourrier, dateReception, this.dossier.date_reception_courrier, this.dossier.date_reception)
                  // console.log(this.dossier.date_reception_courrier.split(' ')[0], this.dossier.date_reception.split(' ')[0])
                  if (dateReceptionCourrier > dateReception) {
                    valid = false;
                    this.errors.dateReceptionCourrier = 'La date de réception réelle ne peut pas être supérieure à la date de réception dans Atlas';
                  }
                }
              }
              break;
            case 'selectedAccuseReception':
              if (isEmpty(this.dossier.selectedAccuseReception) && isEmpty(this.dossier.accuse_reception)) {
                valid = false;
                this.errors.selectedAccuseReception = 'Vous devez choisir le type d\'accusé de réception';
              }
              break;
            case 'selectedMotifsRejet':
              if (isEmpty(this.dossier.selectedMotifsRejet)) {
                valid = false;
                this.errors.selectedMotifsRejet = 'Vous devez choisir au moins un motif de non conformité';
              }
              break;
            case 'reponseDb':
              if (isEmpty(this.dossier.reponseDb) && isEmpty(this.dossier.dbco_reponse)) {
                valid = false;
                let typeDbcoDossier = !isEmpty(this.dossier.dbcoType) ? this.dossier.dbcoType : this.dossier.dbco_type;
                this.errors.reponseDb = isEmpty(typeDbcoDossier) ? '' : (typeDbcoDossier.toLowerCase() === 'db' ? 'Vous devez choisir la clause' : 'Vous devez choisir une option');
              }
              break;
            case 'dbcoType':
              if (isEmpty(this.dossier.dbcoType) && isEmpty(this.dossier.dbco_type)) {
                valid = false;
                this.errors.dbcoType = 'Vous devez choisir entre Désignation de bénéficiaire (DB) ou Choix d\'option (CO)';
              }
              break;
            case 'isConforme':
              if (isEmpty(this.dossier.isConforme) && isEmpty(this.dossier.is_conforme)) {
                valid = false;
                this.errors.isConforme = 'Vous devez choisir l\'état de conformité du document';
              }
              break;
            case 'id_pp':
              if (isEmpty(this.ppNumber) && isEmpty(this.dossier.id_pp)) {
                valid = false;
                this.errors.ppNumber = 'L\'ID PP NSI est obligatoire';
              }
              break;
            case 'causeSinistreId':
              if (isEmpty(this.dossier.cause_sinistre_id) && isEmpty(this.dossier.causeSinistreId)) {
                valid = false;
                this.errors.causeSinistreId = 'Vous devez sélectionner une cause de sinistre.';
              }
              break;
            default:
              break;
          }
        }

        let typeDossierId = this.allTypes
          .filter(type => type.libelle_technique === 'ij_ouv' || type.libelle_technique === 'ij_prol')
          .map(type => type.id);
        if (this.isIjGestionPrestation && this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && isEmpty(this.dossier.date_debut_periode) && typeDossierId.indexOf(this.dossier.type_id) > -1) {
          valid = false;
          this.errors.date_du = 'La date de début de période est obligatoire';
        }

        this.$event.emit('saveError', this.errors);
        this.$event.emit('validateIncident', valid);
        return valid;
        // return false;
      },
      validateSiren: _.debounce(function (event) {
        this.errors.siren = checkSIREN(event.target.value) ? '' : 'Saisir un siren valide';
        this.showFicheSiren = checkSIREN(event.target.value);
      }, 1000),
      validateNic: _.debounce(function () {
        this.errors.nic = '';
        if (this.nic.length === 5) {
          if (this.siren !== '') {
            // this.validateSiren;
            this.errors.nic = ''
          }
        } else {
          this.errors.nic = 'Saisir un NIC valide';
        }
      }, 1000),
      validateNirWithoutKey: _.debounce(function () {
        this.errors.nirWithoutKey = '';
        if (this.nirWithoutKey.length === 13) {
          if (this.keyNir !== '') {
            this.validateNIR();
          }
        } else {
          this.errors.nirWithoutKey = 'Saisir un NIR valide';
        }
      }, 1000),
      validateKeyNir: _.debounce(function () {
        this.errors.keyNir = '';
        if (this.keyNir.length === 2) {
          if (this.nirWithoutKey !== '') {
            this.validateNIR();
          }
        } else {
          this.errors.keyNir = 'Saisir une clé valide';
        }
      }, 1000),
      validateNIR() {
        if (!this.isIjValidationDossierPrestation && !this.isEditRibPrestation) {
          this.validNir = checkNIR(this.nirWithoutKey + this.keyNir)
        }
        return this.validNir;
      },
      getDonneesSinistre(data) {
        this.dossier.date_debut_periode = data.dateDebutSinistre;
        this.dossier.date_fin_periode = data.dateFinSinistre;
        this.dossier.date_fait_generateur = data.dateFaitGenerateur;
        this.dossier.date_pam = data.datePam;
        this.dossier.date_effet = data.dateEffet;
        this.dossier.date_deces = data.dateDeces;
        this.dossier.type_deces = data.typeDeces;
        this.dossier.montant_ij_ss = data.montantIJSS;
        this.dossier.montant_ij_ss_net = data.montantIJSSNet;
        this.dossier.has_montant_ij_ss_variant = data.hasMontantIJSSVariant;
        this.dossier.is_cause_tiers = data.IsCauseTiers;
        this.dossier.is_salarie_sorti_effectif = data.isSalarieSortiEffectif;
        this.dossier.is_salarie_en_mtt = data.isSalarieEnMTT;
        this.dossier.date_suspension_contrat = data.dateSuspensionContrat;
        this.dossier.date_reprise_temps_complet = data.dateRepriseTempsComplet;
        this.dossier.categorie_inval = data.categorieInval;
        this.dossier.categorie_inval_initial = data.categorieInvalInitial;
        this.dossier.numero_archive = data.numArchives;
        this.dossier.commentaire_sinistre = data.commentaire;
        this.dossier.date_reception = data.dateReception;
        this.dossier.date_reception_courrier = data.dateReceptionCourrier;
        this.dossier.date_courrier_initialisation = data.dateCourrierInitialisation;
        this.dossier.canal_id = data.selectedCanal;
        this.dossier.numero_psi = data.numPsi;
        this.dossier.taux_incapacite = data.taux;
        this.dossier.taux_incapacite_initial = data.tauxInitial;
        this.dossier.rar = data.rar;
        this.dossier.emetteur = data.emetteur;
        this.dateDebutSinistreIndisponible = data.dateDebutIndisponible;
        // let findCapital = false;
        // let findCapitalPlus = false;
        // for (let capital of data.capitalDeces) {
        //   if (capital === 'capital') {
        //     findCapital = true;
        //   }
        //   if (capital === 'capital_plus') {
        //     findCapitalPlus = true;
        //   }
        // }
        // this.dossier.capital_verse = findCapital;
        // this.dossier.capital_superieur = findCapitalPlus;
        // let findRenteConjoint = false;
        // let findRenteEducation = false;
        // let findRenteOcirp = false;
        // let findAllocationsObseques = false;
        // if(!isEmpty(data.allocationsObseques)){
        //   findAllocationsObseques = true;
        // }
        // for (let type of data.typeRente) {
        //   if (type === 'conjoint') {
        //     findRenteConjoint = true;
        //   }
        //   if (type === 'education') {
        //     findRenteEducation = true;
        //   }
        //   if (type === 'ocirp') {
        //     findRenteOcirp = true;
        //   }
        // }
        // this.dossier.rente_conjoint = findRenteConjoint;
        // this.dossier.rente_education = findRenteEducation;
        // this.dossier.rente_ocirp = findRenteOcirp;
        // this.dossier.has_allocations_obseques = findAllocationsObseques;
        this.dossier.date_information_deces = data.dateInfoDeces;
        this.dossier.source_information = data.sourceInfo;
        this.dossier.numero_contrat = data.numContrat;
        this.dossier.cause_sinistre_id = data.causeSinistreId;
        this.dossier.dossier_id_fait_generateur = data.dossierIdFaitGenerateur;
        this.dossier.precision_cause = data.precision_cause;
        //this.dossier.is_exclude_traitement_auto = data.exclusion_traitement_auto;
        // On met également à jour la data pour que la coche s'affiche aussi dans le bloc type/produit
        this.exclusion_traitement_auto = data.exclusion_traitement_auto;
        this.dossier.libelle_regle_cumul = data.selectedRegleCumul;
        this.dossier.motif_non_pec = data.selectedFlag;
        this.dossier.is_non_eligible_cloture_auto = data.nonEligibleClotureAuto;
        this.dossier.numero_evenement_nsi = data.numeroEvenementNsi;
        this.dossier.attestation_ressource = data.attestationRessource;
      },
      getDonneesDbco(data) {
        // this.dossier.dateSignature = data.dateSignature;
        this.dossier.dateSignature = data.dateSignature + ' ' + data.timeSignature;
        this.dossier.selectedMotifsRejet = data.selectedMotifsRejet;
        this.dossier.reponseDb = data.reponseDb;
        this.dossier.typeSupport = data.typeSupport;
        this.dossier.dbcoType = data.dbcoType;
        this.dossier.garantiePret = data.garantiePret;
        this.dossier.dateReceptionCourrier = data.dateReceptionCourrier;
        this.dossier.isConforme = data.isConforme;
        this.dossier.selectedAccuseReception = data.selectedAccuseReception;
        this.dossier.dbcoUuid = data.dbcoUuid;
        this.dossier.yousignId = data.yousignId;
      },
      getDonneesDroitAssure(data) {
        // console.log('data',data)
        data.nic_nouveau_contrat = String(data.nic_nouveau_contrat).padStart(5, '0');
        this.dossier.droitAssure = data;
        this.siren = data.siren_employeur;
        this.nic = String(data.nic_employeur).padStart(5, '0');
      },
      getDonneesCompletudeDossier(data) {
        this.dossier.completudeDossier = data;
      },
      getDonneesSalaireDossier(data) {
        this.dossier.itemsSalaire = data.itemsSalaire;
        this.dossier.moyennePrime = data.moyennePrime;
        this.dossier.moyenneSalaireBrut = data.moyenneSalaireBrut;
        this.dossier.moyenneTauxCharge = data.moyenneTauxCharge;
        this.dossier.taux_a = data.taux_a;
        this.dossier.taux_b = data.taux_b;
        this.dossier.taux_c = data.taux_c;
        this.dossier.totalPrime = data.totalPrime;
        this.dossier.totalSalaire = data.totalSalaire;
      },
      getDonneesQualite(data) {
        this.dossier.commentaire_qualite = data.commentaire;
      },
      getDonneesIncidents(data) {
        // console.log('dans dossier.vue -> getDonneesIncidents')
        this.dossier.commentaire_sinistre = data.commentaire;
      },
      getDonneesDemandesClients(data) {
        this.dossier.commentaire_client = data.commentaireDemandeClient;
        this.dossier.commentaire_gestion = data.commentaireSuiviGestion;
        this.dossier.contact_nom = data.nomInterlocuteur;
        this.dossier.contact_tel = data.telInterlocuteur;
        this.dossier.contact_email = data.mailInterlocuteur;
        this.dossier.date_demande_client = moment(data.date, 'YYYY-MM-DD');
      },
      getDonneesCommunications(data) {
        // this.dossier.commentaire_client = data.commentaireDemandeClient;
        // this.dossier.commentaire_gestion = data.commentaireSuiviGestion;
        // this.dossier.contact_nom = data.nomInterlocuteur;
        // this.dossier.contact_tel = data.telInterlocuteur;
        // this.dossier.contact_email = data.mailInterlocuteur;
        // this.dossier.date_demande_client = moment(data.date, 'YYYY-MM-DD');
        console.log(data)
      },
      getDonneesSuiviDossier(data) {
        // console.log('dans dossier.vue->getDonneeSuiviDossier : data',data)
        // On remet à zero les requiredFields dans ce cas pour qu'il ne reste pas en mémoire si on change le statut du traitement secondaire
        this.requiredFields = [];
        this.dossier.status_id = data.sousStatutActuel ? data.sousStatutActuel : data.statutActuel;
        this.dossier.main_treatment_status_id = data.statusMainTreatment;
      },
      shortFormatDate(textDate) {
        let formattedDate = null;
        if (!isEmpty(textDate)) {
          let date = new Date(textDate).toLocaleDateString("fr-FR").split('/');
          formattedDate = `${date[0]}-${date[1]}-${date[2].slice(-2)}`;
        }
        return formattedDate;
      },
      getTypes() {
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getAllType")
          .then(response => {
            this.allTypes = response.data.data;
            for (let type of response.data.data) {
              if (type.libelle_technique !== 'ijl' && type.libelle_technique !== 'ij-bpij' && type.libelle_technique !== 'bpijo' && type.libelle_technique !== 'bpijp' && type.libelle_technique !== 'ijri') {
                // Il ne faut pas que les dossiers non arrivés par le canal DBCO puisse être typé en DBCO
                if (this.isConformiteDBCO || this.isValidationConformiteDBCO || (!this.isConformiteDBCO && !this.isValidationConformiteDBCO && type.libelle_technique != 'dbco')) {
                  this.allTypesOption.push({value: type.id, text: type.libelle});
                }
              }
            }
          })
          .catch((error) => {
            self.handleError(error);
          });
      },
      getFamillesProduits() {
        // TODO : Ajouter un libellé technique à la table famille produit ou une colonne ordre pour éviter de travaillé avec un libellé qui peut changer
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getAllProduit")
          .then(response => {
            let nonDetermine = {};
            for (let famille of response.data.data) {
              if (famille.libelle !== 'Non déterminé') {
                this.allFamillesProduits.push({value: famille.id, text: famille.libelle});
              } else {
                nonDetermine = famille;
              }
            }
            this.allFamillesProduits.unshift({value: nonDetermine.id, text: nonDetermine.libelle});
            this.groupSelectOption = {};
            for (let famille of response.data.data) {
              let secteur = famille.secteur.split(',')
              if (secteur.indexOf('ess') > -1) {
                if (this.groupSelectOption.ess === undefined) {
                  this.groupSelectOption.ess = [];
                }
                if (famille.libelle !== 'Non déterminé') {
                  this.groupSelectOption.ess.push({value: famille.id, text: famille.libelle});
                }

              } else {
                if (this.groupSelectOption[secteur[0]] === undefined) {
                  this.groupSelectOption[secteur[0]] = [];
                }
                this.groupSelectOption[secteur[0]].push({value: famille.id, text: famille.libelle});
              }
            }
            this.groupSelectOption.ess.unshift({value: nonDetermine.id, text: nonDetermine.libelle});
            // TODO : gérer un array hors groupe pour les produit comme Non déterminé
            // console.log('this.groupSelectOption',this.groupSelectOption)
          })
          .catch((error) => {
            self.handleError(error);
          });
      },
      getLibelleStatus() {
        if (this.dossier) {
          if (parseInt(this.$route.query.traitementId) === 11) {
            // this.statutActuelLibelle = 'A contrôler';
            let campagneId = parseInt(this.$route.query.campagneId)
            this.$axios
              .get("/espaceQualite/controles/dossierId/" + this.dossier.id + '/' + campagneId)
              .then(response => {
                this.controleDossier = response.data.controle
                this.statutActuelLibelle = response.data.status.libelle_bo
              })
              .catch((error) => {
                // self.$store.commit('IS_LOADING', false)
                  let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
                  self.$swal({
                  position: 'top',
                  type:'error',
                  title:'Attention !!',
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          } else {
            for (let status of this.dossier.status) {
              if (parseInt(status.pivot.traitement_id) === parseInt(this.$route.query.traitementId)) {
                this.statutActuelLibelle = status.parent ? status.parent.libelle_bo + ' - ' + status.libelle_bo : status.libelle_bo;
                this.statutActuelLibelleTech = status.parent ? status.libelle_technique : status.libelle_technique;
              }
            }
          }
        }
      },
      ficheSiren() {
        if (!isEmpty(this.siren) && checkSIREN(this.siren)) {
          let link = document.createElement("a");
          link.href = "/espace-gestion/sirens/fiche/" + this.siren;
          document.body.appendChild(link);
          window.open(link, "_blank");
        }
      },
      next() {
        // console.log('dans next, this.$route.query.seqDossiers : ',this.$route.query.seqDossiers)
        let dossiersIds = [];
        if (typeof this.$route.query.seqDossiers === 'string') {
          dossiersIds.push(this.$route.query.seqDossiers);
        } else {
          dossiersIds = this.$route.query.seqDossiers.map(function (id) {
            return parseInt(id, 10);
          });
        }
        // const dossiersIds = this.$route.query.seqDossiers.map(function (id) {
        //   return parseInt(id, 10);
        // });
        if (dossiersIds.length > 0) {
          let nextId = null;
          // const currentDossierId = parseInt(this.$route.params.id);
          // let index = dossiersIds.indexOf(currentDossierId);
          // if (index >= 0 && index < dossiersIds.length - 1) {
          //   nextId = dossiersIds[index + 1];
          // }
          nextId = dossiersIds.shift();
          // console.log('nextId',nextId)
          if (nextId) {
            this.$route.query.seqDossiers = dossiersIds;
            // On enlève de la sequence "related" le dossier qu'on va afficher pour ne pas repasser dessus
            if (!isEmpty(this.$route.query.seqRelatedDossiers) && this.$route.query.seqRelatedDossiers.indexOf(nextId) > -1) {
              let seqRelatedDossiers = this.getSeqDossiers(this.$route.query.seqRelatedDossiers);
              seqRelatedDossiers.splice(seqRelatedDossiers.indexOf(nextId),1);
              this.$route.query.seqRelatedDossiers = seqRelatedDossiers;
            }
            if (this.$route.query.traitementId && this.$route.query.campagneId) {
              this.$router.push({path: `/espace-qualite/controle-qualite/dossier/show/${nextId}`, query: this.$route.query});
            }
            else {
              // On regarde s'il y a un previousTraitementId (cas d'un changement de type de dossier), auquel cas il faut charger le dossier suivant avec l'ancien traitement et non le traitement du dossier actuel, car la sequence de dossier correspond a des dossiers de l'ancien traitement
              let queries = _.clone(this.$route.query);
              if (!isEmpty(this.$route.query.previousTraitementId)) {
                queries.traitementId = this.$route.query.previousTraitementId;
                // console.log('queries', queries)
                delete queries.previousTraitementId;
              }

              this.$router.push({path: `/espace-gestion/dossier/show/${nextId}`, query: queries});
            }
            window.location.reload();
          }
        }
      },
      disableNextButton() {
        let dossiersIds = this.getSeqDossiers(this.$route.query.seqDossiers);

        return dossiersIds.length === 0
      },
      nextRelated() {
        let dossiersIds = [];
        if (typeof this.$route.query.seqRelatedDossiers === 'string') {
          dossiersIds.push(this.$route.query.seqRelatedDossiers);
        } else {
          dossiersIds = this.$route.query.seqRelatedDossiers.map(function (id) {
            return parseInt(id, 10);
          });
        }
        // console.log('this.$route.query.seqRelatedDossiers',typeof this.$route.query.seqRelatedDossiers)
        // let dossiersIds = this.$route.query.seqRelatedDossiers.map(function (id) {
        //   return parseInt(id, 10);
        // });
        if (dossiersIds.length > 0) {
          let nextId = null;

          nextId = dossiersIds.shift();
          if (nextId) {
            // Si le dossier est le dernier des "related" on met 0 dans le tableau de sequence pour savoir au prochain chargement qu'il ne faut plus afficher le bouton
            if (isEmpty(dossiersIds)) {
              dossiersIds.push(0);
              this.$route.query.lastRelated = nextId;
            }
            this.$route.query.seqRelatedDossiers = dossiersIds;
            // On en lève de la sequence "normale" le dossier related qu'on va afficher pour ne pas repasser dessus
            if (this.$route.query.seqDossiers.indexOf(nextId) > -1) {
              let seqDossiers = this.getSeqDossiers(this.$route.query.seqDossiers);
              seqDossiers.splice(seqDossiers.indexOf(nextId),1);
              this.$route.query.seqDossiers = seqDossiers;
            }

            let queries = _.clone(this.$route.query);
            if (!isEmpty(this.$route.query.previousTraitementId)) {
              queries.traitementId = this.$route.query.previousTraitementId;
              // console.log('queries', queries)
              delete queries.previousTraitementId;
            }

            this.$router.push({path: `/espace-gestion/dossier/show/${nextId}`, query: queries});
            window.location.reload();
          }
        }
      },
      showNextRelatedButton() {
        let dossiersIds = this.getSeqDossiers(this.$route.query.seqRelatedDossiers);
        // Si dossiersIds[0] === 0 alors on est sur le dernier de la sequence related
        return dossiersIds.length > 0 && dossiersIds[0];
      },
      getSeqDossiers(seqDossiers) {
        if (!isEmpty(seqDossiers)) {
          if (typeof seqDossiers !== 'string') {
            seqDossiers = seqDossiers.map(function (id) {
              return parseInt(id, 10);
            });
          } else {
            seqDossiers = [parseInt(seqDossiers, 10)];
          }
        } else {
          seqDossiers = [];
        }
        return seqDossiers;
      },
      canDuplicate() {
        if (this.isQualification) {
          let user = getUser();
          let traitementsIds = user.profil_active[0].traitements.map((traitement) => parseInt(traitement.id));
          if (traitementsIds.indexOf(parseInt(this.$route.query.traitementId,10)) > -1) {
            this.disableDuplication = false;
          }
        }
      },
      getIconSrc(type) {
        let images = require.context('@/assets/images/', false, /\.png$/);
        return images('./' + type)
      },
      async getRequiredFields() {
        return new Promise( async (resolve, reject) => {
          if (this.dossier) {
            // Les statuts « A affecter », « A traiter » et « Traité » avec le sous-statut « Supprimé » ne sont soumis à aucune donnée obligatoire.
            // Les traitements secondaire ne sont pas non plus soumis à validation
            let currentTraitement = this.allTraitements.reduce((res,traitement) => {
              return traitement.id === parseInt(this.$route.query.traitementId,10) ? traitement : res;
            },{});
            if (this.dossier.status_id === null || this.dossier.status_id === undefined || (this.statusAbandon.id === this.dossier.status_id) || (this.statusDejaTraite.id === this.dossier.status_id) || (this.statusTraiteSupprime.id === this.dossier.status_id) || (this.statusRefusPriseEnCharge.id === this.dossier.status_id) || (this.statusPassageManuel.id === this.dossier.status_id) || (this.statusBasculeModulePrev.id === this.dossier.status_id) || (!isEmpty(currentTraitement) && currentTraitement.type.toLowerCase() === 'secondaire')) {
              // =================================== CASE 13 ==> Traitement Expert : Traité et finalisé NSI  ===================================
              if (this.currentTreatment.libelle_technique === 'ij_expertise_presta_niv2' || this.currentTreatment.libelle_technique === 'controle_prestation') {
                // Pour le statuts « Traités et finalisation dans NSI »
                let choosenStatus = this.currentTreatment.status.reduce((res,status) => status.id === parseInt(this.dossier.status_id,10) ? status : res, null);
                if (choosenStatus && choosenStatus.libelle_technique === 'traite_finalise_nsi') {
                  await this.getRequiredFieldsByTraitementId(this.dossierMainTreatment.id);
                  this.requiredFields.push('main_treatment_status_id');
                  this.verifyCheckBoxes = false;
                  this.noValidationRequired = false;
                } else if (choosenStatus && choosenStatus.libelle_technique === 'traite' && this.currentTreatment.libelle_technique === 'controle_prestation') {
                  this.noValidationRequired = false;
                } else {
                  // this.verifyCheckBoxes = false;
                  this.noValidationRequired = true;
                }
              } else if (this.saveIncidentConformite) {
                await this.getRequiredFieldsByTraitementId(currentTraitement.id);
                this.verifyCheckBoxes = false;
                this.noValidationRequired = false;
              } else {
                this.noValidationRequired = true;
              }
            } else {
              this.noValidationRequired = false;
              await this.getRequiredFieldsByTraitementId(this.$route.query.traitementId);
            }
            // console.log('this.requiredFields',this.requiredFields)
            resolve();
          } else {
            resolve();
          }
        });
      },
      getRequiredFieldsByTraitementId(traitementId) {
        return new Promise((resolve, reject) => {
          // ==================================== CASE 1 ==> Qualification Courrier : tous dossiers ====================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('qualification_courrier')) {
            this.verifyCheckBoxes = true;
            this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'date_reception', 'dateReceptionCourrier', 'canal_id','date_debut_periode'];
          }
          // ==================================== CASE 1 ==> Qualification Courrier : DBCO ====================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('qualification_courrier') && this.dossier.type && this.dossier.type.libelle_technique === 'dbco') {
            this.verifyCheckBoxes = true;
            // On supprime les champs adresses des champs obligatoires, en attendant de trouver une solution d'impression du courrier directement depuis Atlas
            this.requiredFields = ['selectedType', 'nirWithoutKey', 'nom', 'nom_naissance', 'prenom', 'siren', 'date_reception', 'dateReceptionCourrier', 'canal_id'];
            // this.requiredFields = ['selectedType', 'nirWithoutKey', 'nom', 'nom_naissance', 'prenom', 'siren', 'date_reception', 'canal_id', 'adresse1', 'adresse2'];
          }
          // =================================== CASE 2 ==> Gestion IJ : dossier ouverture ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('ij_gestion_prestation') && (this.dossier.type.libelle_technique === 'ijo' || this.dossier.type.libelle_technique === 'bpijo')) {
            this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'date_debut_periode'];
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) {
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 3 ==> Gestion IJ : dossier prolongation ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('ij_gestion_prestation') && (this.dossier.type.libelle_technique === 'ijp' || this.dossier.type.libelle_technique === 'bpijp')) {
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id && this.statusRefusPriseEnCharge.id !== this.dossier.status_id) {
              // On regarde si on est dans le cas d'un passage en module Prev' bon pour intégration, auquel cas il faut faire les tests de module Prev'
              // Pour l'instant ce sont les mêmes mais c'est prêt si on doit en avoir des différents
              if (this.statusBasculeModulePrevBonIntegration.id === this.dossier.status_id) {
                this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'date_debut_periode', 'date_fin_periode', 'montant_ij_ss'];
                this.verifyCheckBoxes = false;
              } else {
                this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'date_debut_periode', 'date_fin_periode', 'montant_ij_ss'];
                this.verifyCheckBoxes = false;
              }
            }
          }
          // =================================== CASE 3bis ==> Module Prev' ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('ij_module_prevoyance') || (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('ij_gestion_prestation') && this.statusBasculeModulePrevBonIntegration.id === this.dossier.status_id)) {
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id && this.statusRefusPriseEnCharge.id !== this.dossier.status_id && this.statusPassageManuel.id !== this.dossier.status_id) {
              this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'date_debut_periode', 'date_fin_periode', 'montant_ij_ss', 'id_pp', 'causeSinistreId'];
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 4 ==> Gestion Décès : dossier Initialisation / Ouverture ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_dc') && (this.dossier.type.libelle_technique === 'dci' || this.dossier.type.libelle_technique === 'dc_inc' || this.dossier.type.libelle_technique === 'dcd')) {
            this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nom', 'prenom', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'dateDeces', 'typeDeces', 'date_information_deces', 'beneficiaireTraite'];
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) {
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 5 ==> Gestion Décès : dossier Initialisation / Ouverture ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_dc') && this.dossier.type.libelle_technique === 'dco') {
            this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nom', 'prenom', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'dateDeces', 'typeDeces', 'date_information_deces', 'beneficiaireTraite'];
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) {
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 6 ==> Gestion Décès : dossier Retour de pièces ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_dc') && this.dossier.type.libelle_technique === 'dcr') {
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) {
              this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nom', 'prenom', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'dateDeces', 'typeDeces', 'date_information_deces', 'beneficiaireTraite'];
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 7 ==> Gestion Décès : dossier Justificatif annuel ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_dc') && this.dossier.type.libelle_technique === 'dcja') {
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) {
              this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nom', 'prenom', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'typeDeces', 'beneficiaireTraite'];
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 8 ==> Gestion Invalidité : Ouverture ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_inval') && this.dossier.type.libelle_technique === 'ino') {
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) {
              this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'date_fait_generateur', 'categorieInval', 'dateEffet'];
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 9 ==> Gestion Invalidité : Prolongations  ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_inval') && (this.dossier.type.libelle_technique === 'inp')) {
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) {
              this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'categorieInval'];
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 9bis ==> Gestion Invalidité : Justificatif annuel Invalidité  ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_inval') && (this.dossier.type.libelle_technique === 'invja')) {
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) {
              this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nom', 'prenom', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'categorieInval'];
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 10 ==> Gestion Invalidité : Changement de catégorie  ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_inval') && this.dossier.type.libelle_technique === 'invcc') {
            // console.log('Gestion Invalidité : Changement de catégorie');
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) {
              this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'categorieInval', 'dateEffet'];
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 11 ==> Gestion Incapacité : Ouverture  ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_inval') && this.dossier.type.libelle_technique === 'incao') {
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) {
              this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'taux', 'dateEffet'];
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 12 ==> Gestion Incapacité : Changement de taux  ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_inval') && this.dossier.type.libelle_technique === 'incact') {
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if (this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) {
              this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'dateReceptionCourrier', 'canal_id', 'taux', 'dateEffet'];
              this.verifyCheckBoxes = false;
            }
          }
          // =================================== CASE 13 ==> Gestion Conformité DBCO  ===================================
          if (parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_dbco') || parseInt(traitementId, 10) === this.getTraitementIdByLibelleTehnique('validation_dbco')) {
            // Pour les statuts « Traités » avec des sous-statuts différents de « Supprimé » ou "déjà traité"
            if ((this.statusTraiteIds.indexOf(this.dossier.status_id) > -1 && this.statusDejaTraite.id !== this.dossier.status_id && this.statusTraiteSupprime.id !== this.dossier.status_id) || this.saveIncidentConformite) {
              this.requiredFields = ['selectedType', 'nom', 'nom_naissance', 'prenom', 'date_reception', 'canal_id', 'selectedAccuseReception', 'reponseDb', 'dbcoType', 'isConforme','dateSignature'];
              if (!isEmpty(this.dossier.isConforme) && this.dossier.isConforme === 'false') {
                this.requiredFields.push('selectedMotifsRejet');
              }
              // Si l'AR se fait par mail, on oblige le renseignement de l'adresse mail
              if (!isEmpty(this.dossier.accuse_reception) && this.dossier.accuse_reception === 'ar_mail') {
                this.requiredFields.push('email');
              }
              // Pour les DBCO papier on doit controller la date de réception corrier
              if (!isEmpty(this.dossier.typeSupport) && this.dossier.typeSupport === 'papier') {
                this.requiredFields.push('dateReceptionCourrier');
              }
              this.verifyCheckBoxes = false;
            }
          }
          resolve();
        });
      },
      getAllTraitements() {
        return new Promise((resolve) => {
          let self = this;
          this.$axios
            .get("/administration/traitements")
            .then(response => {
              this.allTraitements = response.data.traitements;
              this.currentTreatment = this.allTraitements.reduce((res,treatment) => {
                return treatment.id === parseInt(this.$route.query.traitementId,10) ? treatment : res;
              },{});
             /* console.log(this.currentTreatment.status)
              if(this.currentTreatment.status){
                this.disableReOpen = false;
              }*/
              this.getTraitementLibelleById()
                .then(() => {
                  this.isTraitementQC = this.isQualification;
                  this.isTraitementQCTypeProduit = this.isQualification;
                  this.canDuplicate();
                  resolve();
                })
            })
            .catch((error) => {
              self.handleError(error);
              resolve();
            });
        });
      },
      isReopenable(){
        if(this.canReopen()){
        //On récupère le statut du traitement courant
        let TreatmentStatus = this.dossier.status.reduce((res,status) => parseInt(this.$route.query.traitementId, 10) === status.pivot.traitement_id ? status : res, {});
        this.disableReOpen = isEmpty(TreatmentStatus) || this.statusTraiteIds.indexOf(TreatmentStatus.id) === -1 || this.currentTreatment.libelle_technique === 'qualification_courrier' || this.currentTreatment.type.toLowerCase() === 'secondaire';
        }
      },
      isTemporisationBPIJ(){
        //On récupère le statut du traitement courant
        let TreatmentStatus = this.dossier.status.reduce((res,status) => parseInt(this.$route.query.traitementId, 10) === status.pivot.traitement_id ? status : res, {});
        this.disableDeneutralisationTempoBPIJ = !(this.statusNeutraliseTemporisationId === TreatmentStatus.id);
      },
      getTraitementIdByLibelleTehnique(libelle_technique) {
        let treatment = _.find(this.allTraitements, function (element) {
          return element.libelle_technique === libelle_technique;
        });
        return treatment && treatment.id;
      },
      getStatusIdByLibelleTehnique(libelle_technique) {
        let status = _.find(this.allStatus, function (element) {
          return element.libelle_technique === libelle_technique;
        });
        return status && status.id;
      },
      verifyBeforeSaveIncident() {
        if (parseInt(this.$route.query.traitementId, 10) === this.getTraitementIdByLibelleTehnique('ij_gestion_prestation') && (this.dossier.type.libelle_technique === 'ij_ouv' || this.dossier.type.libelle_technique === 'ij_prol')) {
          this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'canal_id', 'date_debut_periode'];
          this.verifyCheckBoxes = true;
          this.validateSave();
        }
        if (parseInt(this.$route.query.traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_dc') && (this.dossier.type.libelle_technique === 'dco' || this.dossier.type.libelle_technique === 'dcr' || this.dossier.type.libelle_technique === 'dcja')) {
          this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'canal_id'];
          this.verifyCheckBoxes = true;
          this.validateSave();
        }
        if (parseInt(this.$route.query.traitementId, 10) === this.getTraitementIdByLibelleTehnique('gestion_inval') && (this.dossier.type.libelle_technique === 'ino' || this.dossier.type.libelle_technique === 'inp' || this.dossier.type.libelle_technique === 'invja' || this.dossier.type.libelle_technique === 'invcc' || this.dossier.type.libelle_technique === 'incao' || this.dossier.type.libelle_technique === 'incact')) {
          this.requiredFields = ['selectedType', 'selectedFamilleProduit', 'nirWithoutKey', 'nom', 'prenom', 'siren', 'date_reception', 'canal_id'];
          this.verifyCheckBoxes = true;
          this.validateSave();
        }
        else {
          this.$event.emit('validateIncident', true);
        }
      },
      getDossierTraitementByType() {
        return getMainTreatmentBasedOnType(this.dossier, this.allTraitements);
      },
      getRaisonSociale(libelle) {
        let response = {libelle: '', isTruncated: false};
        if (libelle) {
          if (libelle.length >= 43) {
            response.libelle = libelle.substring(0,40)+'...';
            response.isTruncated = true;
          } else {
            response.libelle = libelle;
            response.isTruncated = false;
          }
        }
        return response;
      },
      verifierConditionAffichageMsgNsi() {
        // Vérifier la condition pour afficher le message traité NSI
        // Vérifier le passage aux statuts traités autres que « Traité –supprimé » et « Traité – déjà traité »
        // et que pour les traitements principaux autre que PFE et DBCO (parce que ne traitent pas dans NSI).
        const statusTraiteReel = this.statusTraite.sous_statuts.filter(status => {
          return status.libelle_technique !== 'deja_traite' && status.libelle_technique !== 'traite_supprime';
        });
        let statusTraiteReelIds = _.map(statusTraiteReel, (item) => item.id);
        // Ajouter le statut parent aussi.
        statusTraiteReelIds.push(this.statusTraite.id);
        const traitementConcerne = _.filter(this.allTraitements,(traitement) => {
          return traitement.type === 'Principal' && traitement.libelle_technique !== 'qualification_courrier' && traitement.libelle_technique !== 'gestion_dbco' && !this.isIjModulePrevoyance && !this.isIjGestionPrestation;
        });
        const traitementConcerneIds = _.map(traitementConcerne, (item) => item.id);
        return statusTraiteReelIds.indexOf(this.dossier.status_id) > -1 && traitementConcerneIds.indexOf(parseInt(this.$route.query.traitementId,10)) > -1;
      },
      getResultats() {
        let self = this;
        // this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceQualite/getResultatsControle')
          .then(response => {
            // this.$store.commit('IS_LOADING', false);
            const resultatsControle = response.data.resultats_controle;
            const resultatOK = resultatsControle.find(element => element.libelle_technique === 'ok');
            this.resultatOKId = !isEmpty(resultatOK) ? resultatOK.id : null;

            let resultatAppuiExpert = response.data.resultats_appui_expert
            let resultatAutre = _.filter(resultatsControle, ['traitement_id', null])

            for (let i = 0; i < resultatAppuiExpert.length; i++) {
              this.appuiExpertOptions.push({
                text: resultatAppuiExpert[i].libelle,
                value: resultatAppuiExpert[i].id
              });
            }
            for (let i = 0; i < resultatAutre.length; i++) {
              if (resultatAutre[i].libelle_technique !== 'ko' && resultatAutre[i].libelle_technique !== 'non_conforme') {
                this.resultatsOptions.push({
                  text: resultatAutre[i].libelle,
                  value: resultatAutre[i].id
                });
              }
            }
          })
          .catch((error) => {
            console.log(error)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      getMotifsAnomalie(dossier) {
        let self = this;
        if (dossier && !isEmpty(dossier.type)) {
          let dossierType = dossier.type.groupe
          this.$axios
            .get('/espaceQualite/getMotifPrincipalAno/' + dossierType)
            .then(response => {
              // this.$store.commit('IS_LOADING', false);
              const motifsPrincipalAno = response.data.motifs_principal_ano;

              if (this.currentTreatment.libelle_technique === 'ij_expertise_presta_niv2') {
                this.motifsAnomalieOptions = null;
              }
              else {
                for (let i = 0; i < motifsPrincipalAno.length; i++) {
                  this.motifsAnomalieOptions.push({
                    text: motifsPrincipalAno[i].libelle,
                    value: motifsPrincipalAno[i].id
                  });
                }
              }
            })
            .catch((error) => {
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      getTabTitle(tab) {
        if (tab === 'Histo sinistres') {
          return this.isNotDbco ? tab : 'Histo DBCO';
        }
      },
      toggleAll(checked) {
        this.selectedBloquedDossier = checked ? this.relatedBloquedDossiers.map(item => {
          return item.id
        }) : []
      },
      getMotifRouverture() {
        let self = this;
        this.$axios
          .get('/espaceGestion/dossier/getMotifRouverture')
          .then(response => {
            for (let motif of response.data.motifs) {
              this.motifReopenOptions.push({value: motif.id, text: motif.libelle});
            }
          })
          .catch((error) => {
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la récupération des motifs de rouverture. Si le problème persiste, merci de faire un ticket au support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      getTypeDossier() {
        let selectedType = this.allTypes.reduce((res,type) => parseInt(type.id,10) === parseInt(this.selectedType,10) ? type : res,{});
        // let selectedType = this.$parent.$parent.$parent.allTypes.reduce((res,type) => parseInt(type.id,10) === parseInt(this.$parent.$parent.$parent.selectedType,10) ? type : res,{});
        // console.log('selectedType',selectedType)
        return !isEmpty(selectedType) ? selectedType.groupe.toLowerCase() : '';
        // return this.dossier.type ? this.dossier.type.groupe.toLowerCase() : '';
      },
      hasJournalDeces() {
        let hasJournalDeces = false
        let commentaireSuivi = this.dossier.suivis.find(suivi => suivi.commentaire === 'signalisation_deces_assure');
        // console.log('commentaireSuivi', commentaireSuivi)
        if (commentaireSuivi === undefined) {
          hasJournalDeces = false
        } else {
          hasJournalDeces = true
        }

        return hasJournalDeces;
      },
      getDestinataireRapport() {
        let self = this
        this.$axios
          .get("/administration/rapports")
          .then(response => {
            // this.items = response.data.rapports;
            let rapportDeces = response.data.rapports.find(rapport => rapport.libelle_technique === 'signalisation_deces_assure');
            this.destinataires = rapportDeces.destinataires
          })
          .catch(() => {
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Un probléme est survenu, merci de contacter l'administrateur",
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      initiateMailDeces() {
        this.mailTo = this.destinataires;
        this.mailCc = "";
        this.mailSubject = "Signalisation du décès de l'assuré " + this.dossier.nom + ' ' + this.dossier.prenom;

        // console.log('dossier_pj', this.dossier.pieces_jointes)

        this.$refs['modal-mail-signalisation-deces'].show();
      },
      cancelMailDeces() {
        this.$refs['modal-mail-signalisation-deces'].hide();
        this.errors.date_deces = '';
        this.date_deces = ''
      },
      validateSendMailDeces() {
        let valid = true;

        if (isEmpty(this.date_deces)) {
          valid = false;
          this.errors.date_deces = 'La date du décès est obligatoire';
        }

        if (this.date_deces > this.maxDateDeces) {
          valid = false;
          this.errors.date_deces = 'La date du décès ne doit pas être posterieure à la date du jour';
        }

        return valid;
      },
      sendMailDeces() {
        if (this.validateSendMailDeces()) {
          let self = this;
          let dataPost = {
            traitementId: this.$route.query.traitementId,
            typeMail: "signalisation_deces_assure",
            dossierId: this.dossier.id,
            mailTo: this.mailTo,
            mailCc: this.mailCc,
            mailObject: this.mailSubject,
            dateDeces: this.date_deces
          }
          this.$store.commit('IS_LOADING', true);
          this.$axios
            .post('/espaceGestion/dossier/send-mail-deces', dataPost)
            .then(response => {
              this.$event.emit('refreshDossier');
              this.$store.commit('IS_LOADING', false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Succès !",
                text: 'Mail envoyé avec succès.',
                showConfirmButton: false,
                timer: 3000
              });
              this.$refs['modal-mail-signalisation-deces'].hide();
            })
            .catch(function () {
              self.$store.commit('IS_LOADING', false);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      manageSirenIdpp() {
        let idppData = this.dataIdpps.find(item => item.id_pp +'-'+item.siren === this.selectedIdpp);
        // console.log(this.siren , idppData.siren, this.siren !== idppData.siren)
        if (this.siren !== idppData.siren) {
          this.siren = idppData.siren;
          this.raisonSociale = '';
        }
      },
      hasTraitementDeces() {
        let user = getUser();
        let traitementDc = user.profil_active[0].traitements.find((traitement) => traitement.libelle_technique === 'gestion_dc');
        return !isEmpty(traitementDc);
      },
      getFormattedDateTime(textDate) {
        if(textDate !== null && textDate !== ''){
          return formatDateTime(textDate, '/');
        }
      },
      showFicheAssure(nir,oag,oap){
        //let url = 'http://remi-backoffice.chorum.fr:8003/espace-gestion/assures/fiche/285084218710770?do=&ns=2850842187107&oag=92063&oap=75045';
        window.open(`/espace-gestion/assures/fiche/${nir}?ns=${nir}&oag=${oag}&oap=${oap}`, '_blank')
      },
      getNumPpFromApi(nirComplet){
        let self = this;
        this.loadingIdppApi = true;
        if(!isEmpty(nirComplet) && nirComplet.length >= 13){
          let nirSansCle = nirComplet.substring(0,13);
          let dataPost = {
                nir: nirSansCle
          }
          this.$axios
              .post('/referentielClient/assures/getNumPpFromApi', dataPost)
              .then(response => {
                /*console.log('response.data.data',response.data.data);
                console.log('response.data.data.message',response.data.data.message);*/
                  this.loadingIdppApi = false;
                  if(!isEmpty(response.data.data.adherent) && !isEmpty(response.data.data.adherent.idAdherent)){
                    this.idppApi = response.data.data.adherent.idAdherent;
                  }else if(!isEmpty(response.data.data.message)){
                    this.idppApi = response.data.data.message;
                  }else{
                    this.idppApi = 'Erreur API';
                  }
                  let idppFromApi = parseInt(this.idppApi,10);
                  // console.log('idppFromApi',idppFromApi)
                  // console.log('isNaN(idppFromApi)',isNaN(idppFromApi))
                  if (!isEmpty(this.idppApi) && this.idppApi !== 'Erreur API' && !isNaN(idppFromApi) && isEmpty(this.ppNumber)) {
                    this.ppNumber = this.idppApi;
                  }
              })
              .catch((error) => {
                self.loadingIdppApi = false;
                if(error.response && error.response.status === 403){
                  this.idppApi = 'Numéro user NSI manquant';
                }else{
                  self.idppApi = 'Erreur technique API';
                }
              });
        }else{
          this.loadingIdppApi = false;
          this.idppApi = 'Veuillez compléter le NIR';
        }
        this.loadingIdppApi = false;
      },
      checkCompletudeInvalPfe(){
        if(this.isQualification && this.getTypeDossier() === 'inval' 
          && ((this.dossier.categorie_inval == null || this.dossier.categorie_inval === '') 
          || (this.dossier.date_effet == null || this.dossier.date_effet == ''))){
            return false;
        }else{
            return true;
        }
      },
      cantEditFicheDC
    }
  };
</script>
<style scoped>
  .IZ-select {
    display: inline-block;
  }
</style>
<style lang="scss">
  .custom-input {
    display: inline-block !important;
    width: 92%;
  }
  .custom-input-reduit {
    display: inline-block !important;
    width:80%;
  }
  .custom-checkbox {
    display: inline-block !important;
    margin-left: 5px;
  }
  .like-input-disabled {
    display: inline-block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #5c6873;
    background-clip: padding-box;
    border: 1px solid #e4e7ea;
    border-radius: 0.25rem;
    background-color: #e4e7ea;
    opacity: 1;
  }

  .reduit {
    width: 40%;
  }

  .disabled-input {
    background-color: #c3e6f1 !important;
  }
  .w-0 {
    width: 0px;
  }
</style>
